<template>
  <div class="deviceStatisticNew deviceStatisticAdaptNew">
    <!-- 外包裹盒子辅助页面适配 -->
    <div class="AdaptBoxOut">
      <div class="AdaptBoxIn">
        <!-- 日月元定制能流图 -->
        <!-- 6605 协议定制能流图（devcode == 6605 时渲染） -->
        <div class="section flow eceg-log" v-if="deviceInfo.devcode == 6605" key="flowRYY">
          <!-- 能流加速按钮（未启动mqtt服务时展示；加速中显示加速中并禁用） -->
          <button v-if="collectFastNumFlag&&flowFlagRiyue" @click.stop="getMqttEnergyFlow()" :disabled="energyFlowLoading" style="position: absolute;right: 20px;top:15px;z-index:3;cursor: pointer;background-color:var(--primaryButtonColor, #17C28580);padding: 6px
            10px;border-radius: 8px;color: #fff;">{{ energyFlowLoading ? $t("collectionFrequencyUP.collect_fast_starting") + '...' : $t("collectionFrequencyUP.collect_fast2") }}(<span>{{ surplusNum || 0 }}</span>)</button>
          <!-- 顶部占位区 -->
          <div class="top"></div>

          <!-- 中间能流主体区 -->
          <div class="center">
            <!-- 设备核心图标容器；逆变器 status != 1 时正常显示，否则半透明置灰 -->
            <div class="dev-flow" :style="{opacity: flowData.inverter && flowData.inverter.status != 1 ? 1 : 0.5}">

              <!-- ===== 设备图标 ===== -->
              <!-- 点击打开逆变器弹窗（sy_） -->
              <div class="dev-flow-box" @click="activeDialog = 'sy_'"></div>
              <span class="dev-flow-text">{{ $t("device.brandDevice") }}</span>

              <!-- ===== 上方能流连接线区（电网 ↔ 家庭负载） ===== -->
              <!--
                动态 class 规则（依赖 flowData.grid.status 与 new19DCAer.fd_status[0].status）：
                  有载动画（fd.status===1）：
                    grid.status==1  → flow-effects-dw-dev-jt  (正向有载动画)
                    grid.status==-1 → flow-effects-fd          (反向有载动画)
                    grid.status==3  → flow-effects-dw-dev-fz   (双向有载动画)
                  无载静态（fd 缺失或 fd.status!==1，与动画态互斥互补，覆盖 0/2/-1 等所有非激活值）：
                    grid.status==1 或 3 → flow-effects-dw-dev  (静态连接线)
                    grid.status==-1     → flow-effects-dw      (反向静态连接线)
              -->
              <div class="flow-effects"
                :class="{
                  'flow-effects-dw-dev-jt': flowData.grid && flowData.grid.status == 1  && new19DCAer.fd_status && new19DCAer.fd_status[0] && new19DCAer.fd_status[0].status === 1,
                  'flow-effects-fd':         flowData.grid && flowData.grid.status == -1 && new19DCAer.fd_status && new19DCAer.fd_status[0] && new19DCAer.fd_status[0].status === 1,
                  'flow-effects-dw-dev-fz':  flowData.grid && flowData.grid.status == 3  && new19DCAer.fd_status && new19DCAer.fd_status[0] && new19DCAer.fd_status[0].status === 1,
                  'flow-effects-dw-dev':     flowData.grid && (flowData.grid.status == 1 ) && (!new19DCAer.fd_status || !new19DCAer.fd_status[0] || new19DCAer.fd_status[0].status !== 1),
                  'flow-effects-dw':         flowData.grid && flowData.grid.status == -1 && (!new19DCAer.fd_status || !new19DCAer.fd_status[0] || new19DCAer.fd_status[0].status !== 1),
                }"
              >
                <!-- 电网数值（有值时显示） -->
                <div class="grid-data" v-if="flowData.grid && flowData.grid.val">
                  <div class="data-value">{{ flowData.grid && flowData.grid.val }}</div>
                </div>

                <!-- 家庭负载数值（有值且非零时显示，截断两位小数） -->
                <div class="family-load-data" v-if="new19DCAer.fd_status && new19DCAer.fd_status[0] && new19DCAer.fd_status[0].val && new19DCAer.fd_status[0].status != 0">
                  <div class="data-value">{{ floorVal(new19DCAer.fd_status[0].val) }}{{ new19DCAer.fd_status[0].unit ? new19DCAer.fd_status[0].unit : 'W' }}</div>
                </div>

                <!-- 电网图标；status==0 时半透明置灰，点击打开电网弹窗（gd_） -->
                <div class="grid" @click="activeDialog = 'gd_'" :style="{opacity: flowData.grid && flowData.grid.status == 0 ? 0.5 : 1}">
                  <div class="grid-flow"></div>
                  <span>{{ $t("device.grid") }}</span>
                </div>

                <!-- 家庭负载图标；fd_status[0].status==1 时正常显示，否则半透明置灰 -->
                <div class="family-loadsc" @click="activeDialog = 'hl_'" :style="{opacity: new19DCAer.fd_status && new19DCAer.fd_status[0] && (new19DCAer.fd_status[0].status == 1 || new19DCAer.fd_status[0].status == 2) ? 1 : 0.5}">
                  <div class="family-flow"></div>
                  <span>{{ $t("device.familyLoad") }}</span>
                </div>
              </div>

              <!-- ===== 左下方：电池能流连接线 ===== -->
              <!--
                动态 class 规则（依赖 flowData.battery.status）：
                  status==1  → flow-bottom-left-charging  (充电动画)
                  status==-1 → flow-bottom-left-discharging (放电动画)
              -->
              <div class="flowBottomleft"
                :class="{
                  'flowBottomleftdev': flowData.battery && flowData.battery.status == 1,
                  'flowBottomleftDC':  flowData.battery && flowData.battery.status == -1,
                }"
              >
                <!-- 电池数值（SOC + 功率，有值时显示） -->
                <div class="dc-data" v-if="flowData.battery && flowData.battery.val.length > 0">
                  <div class="dc-data-soc data-value"   v-if="flowData.battery.val[0]">{{ flowData.battery && flowData.battery.val[0] }}</div>
                  <div class="dc-data-value data-value" v-if="flowData.battery.val[1]">{{ flowData.battery && flowData.battery.val[1] }}</div>
                </div>
                <!-- 电池图标；status==0 时半透明置灰，点击打开电池弹窗（bt_） -->
                <div class="dc-flow" @click="activeDialog = 'bt_'" :style="{opacity: flowData.battery && flowData.battery.status == 0 ? 0.5 : 1}">
                  <div class="battow-flow">
                    <img class="battery-img" :src="batteryPath.batterys" alt="">
                  </div>
                  <span>{{ $t("device.battery") }}</span>
                </div>
              </div>

              <!-- ===== 右下方：负载能流连接线 ===== -->
              <!--
                动态 class 规则（依赖 flowData.consumption.status）：
                  status==-1 → flow-bottom-right-gif  (负载动画)
              -->
              <div class="flowBottomright"
                :class="{
                  'flowBottomrightgif': flowData.consumption && flowData.consumption.status == -1,
                }"
              >
                <!-- 负载数值（有值时显示） -->
                <div class="fz-data" v-if="flowData.consumption && flowData.consumption.val">
                  <div class="data-value">{{ flowData.consumption.val }}</div>
                </div>
                <!-- 负载图标；status==0 时半透明置灰，点击打开负载弹窗（bc_） -->
                <div class="dc-flow" @click="activeDialog = 'bc_'" :style="{opacity: flowData.consumption && flowData.consumption.status == 0 ? 0.5 : 1}">
                  <div class="battow-flow"></div>
                  <span>{{ $t("device.consumption") }}</span>
                </div>
              </div>

              <!-- ===== 中间左侧：光伏能流连接线 ===== -->
              <!--
                动态 class 规则（依赖 flowData.generation.status）：
                  status==1 → center-flow-pv-dev  (光伏发电动画)
              -->
              <div class="center-flow-pv"
                :class="{
                  'center-flow-pv-dev': flowData.generation && flowData.generation.status === 1,
                }"
              >
                <!-- 光伏数值（有值时显示） -->
                <div class="pv-data" v-if="flowData.generation && flowData.generation.val">
                  <div class="data-value">{{ flowData.generation && flowData.generation.val }}</div>
                </div>
                <!-- 光伏图标；status==0 时半透明置灰，点击打开光伏弹窗（pv_） -->
                <div class="dc-flow" @click="activeDialog = 'pv_'" :style="{opacity: flowData.generation && flowData.generation.status == 0 ? 0.5 : 1}">
                  <div class="battow-flow"></div>
                  <span>{{ $t("device.solar") }}</span>
                </div>
              </div>

              <!-- ===== 中间右侧：发电机能流连接线 ===== -->
              <!--
                动态 class 规则（依赖 new19DCAer.gn_status[0].status）：
                  status==1 → center-flow-fdj-dev  (发电机运行动画)
              -->
              <div class="center-flow-generator"
                :class="{
                  'center-flow-fdj-dev': new19DCAer.gn_status && new19DCAer.gn_status[0] && new19DCAer.gn_status[0].status === 1,
                }"
              >
                <!-- 发电机数值（有值、status!=0 时显示，截断两位小数；单位优先取接口 unit，无则默认 W） -->
                <div class="generator-data" v-if="new19DCAer.gn_status && new19DCAer.gn_status[0] && new19DCAer.gn_status[0].val && new19DCAer.gn_status[0].status != 0">
                  <div class="data-value">{{ floorVal(new19DCAer.gn_status[0].val) }}{{ new19DCAer.gn_status[0].unit ? new19DCAer.gn_status[0].unit : 'W' }}</div>
                </div>
                <!-- 发电机图标；gn_status[0].status==1 时正常显示，否则半透明置灰 -->
                <div class="dc-flow" @click="activeDialog = 'eg_'"  :style="{opacity: new19DCAer.gn_status && new19DCAer.gn_status[0] && (new19DCAer.gn_status[0].status == 1 || new19DCAer.gn_status[0].status == 2) ? 1 : 0.5}">
                  <div class="battow-flow"></div>
                  <span>{{ $t("device.alternator") }}</span>
                </div>
              </div>

            </div>
          </div>

          <!-- 底部占位区 -->
          <div class="bottom"></div>
        </div>
        <!-- ================= -->
        <div class="section flow" v-else  key="flow">
        <button v-if="collectFastNumFlag&&flowFlagRiyue" @click.stop="getMqttEnergyFlow()" :disabled="energyFlowLoading" style="position: absolute;right: 20px;top:15px;z-index:3;cursor: pointer;background-color:var(--primaryButtonColor, #17C28580);padding: 6px
            10px;border-radius: 8px;color: #fff;">{{ energyFlowLoading ? $t("collectionFrequencyUP.collect_fast_starting") + '...' : $t("collectionFrequencyUP.collect_fast2") }}(<span>{{ surplusNum || 0 }}</span>)</button>
          <!-- <div class="title">{{$t('device.energyFlow')}}</div> -->
          <!-- 滚动时右下角白块遮挡 -->
          <!-- <div class="corner"></div> -->
          <div class="scenecustom" v-if="judgePathName">
            <!-- 图标################################### -->
            <div class="generation-container" @click="activeDialog = 'pv_'">
              <div class="image">
                <div class="generationbox" v-if="flowData.generation.status == 0" style="opacity:0.15"></div>
                <div class="generationbox" v-else></div>
              </div>
              <!-- 光伏板名称
              <span class="name" v-if="flowData.generation.status == 0" style="opacity:0.5"></span>
              <span class="name" v-else></span> -->
            </div>
            <!-- ===继电器relay==================== -->
            <!-- @click="activeDialog='pv_'" -->
            <div v-if="flowData.relay && flowData.relay.length > 0" class="relay-container">
              <div class="image">
                <div class="relaybox" v-if="flowData.relay.status == 0" style="opacity:0.15"></div>
                <div class="relaybox" v-else></div>
              </div>
              <!-- 微逆relay -->
              <span class="label" v-if="flowData.relay.status == 0" style="opacity:0.5">{{ $t("device.relay") }}</span>
              <span class="label" v-else>{{ $t("device.relay") }}</span>
            </div>
            <!-- ===继电器relay==================== -->
            <div class="grid-container" @click="activeDialog = 'gd_'">
              <div class="image">
                <div class="gridbox" v-if="flowData.grid.status == 0" style="opacity:0.15"></div>
                <div class="gridbox" v-else></div>
                <!-- <img v-if="flowData.grid.status" :src="imgPath.grid" /> -->
                <!-- <img v-else src="@/assets/img/grid_disable.png" /> -->
              </div>
              <!-- 电网名称 -->
              <!-- <span class="name" v-if="flowData.grid.status == 0" style="opacity:0.5">{{ $t('device.grid') }}</span>
              <span class="name" v-else>{{ $t('device.grid') }}</span> -->
            </div>
            <div class="inverter-container" @click="activeDialog = 'sy_'">
              <div class="image">
                <!-- <div v-if="collEnergyFlaga">
                  <div class="inverterbox" v-if="websockDevideStatus != 1"></div>
                  <div class="inverterbox" v-else style="opacity:0.15"></div>
                </div>
                <div v-else>
                  <div class="inverterbox" v-if="flowData.inverter.status != 1"></div>
                  <div class="inverterbox" v-else style="opacity:0.15"></div>
                </div> -->
                <div >
                  <div class="inverterbox" v-if="flowData.inverter.status != 1"></div>
                  <div class="inverterbox" v-else style="opacity:0.15"></div>
                </div>
              </div>
              <!-- 设备名称 -->
              <!-- <span class="name" v-if="flowData.inverter.status != 1">{{ $t('device.brandDevice') }}</span>
              <span class="name" v-else style="opacity:0.5">{{ $t('device.brandDevice') }}</span> -->
              <!-- <span class="name">{{flowData.inverter.label}}</span> -->
            </div>
            <!-- 单独拿出判断所用图片 -->
            <div class="battery-container" @click="activeDialog = 'bt_'">
              <!-- <div class="image" v-if="flowData.battery.status == 0" style="opacity:0.15">
                <img :src="batteryPath.batterys" />
              </div>
              <div class="image" v-else-if="flowData.battery.status == -1">
                <img :src="batteryPath.battery" />
              </div>
              <div class="image" v-else>
                <img :src="batteryPath.batterys" />
              </div> -->
              <div class="image">
                <div class="batterybox" v-if="flowData.battery.status != 0"></div>
                <div class="batterybox" v-else style="opacity:0.15"></div>
                <!-- <img
              style="height:130px;width:130px"
              v-if="flowData.inverter.status!==1"
              :src="imgPath.inverter"
            /> -->
                <!-- <img
              style="height:130px;width:130px"
              v-else
              src="@/assets/img/inverter_disable.png"
            /> -->
              </div>
              <!-- <div>
            <img v-if="flowData.battery.status==-1" :src="batteryPath.battery" />
            <img v-else-if="flowData.battery.status==1" :src="batteryPath.batterys" />
            <img v-else :src="batteryPath.batterys" />
          </div> -->
              <!-- 电池名称 -->
              <!-- <span class="name" v-if="flowData.battery.status == 0" style="opacity:0.5">{{ $t('device.battery') }}</span>
              <span class="name" v-else>{{ $t('device.battery') }}</span> -->
            </div>
            <!-- ===发电机alternator==================== -->
            <!-- @click="activeDialog='pv_'" -->
            <div v-if="flowData.alternator && flowData.alternator.length > 0" class="alternator-container">
              <div class="image">
                <!-- <div class="alternatorbox" v-if="flowData.alternator."></div> -->
                <div class="alternatorbox" v-if="flowData.alternator.status == 0" style="opacity:0.15"></div>
                <div class="alternatorbox" v-else></div>
              </div>
              <!-- 发电机alternator -->
              <span class="label" v-if="flowData.alternator.status == 0" style="opacity:0.5">{{ $t("device.alternator") }}</span>
              <span class="label" v-else>{{ $t("device.alternator") }}</span>
            </div>
            <!-- ===发电机alternator==================== -->
            <div class="consumption-container" @click="activeDialog = 'bc_'">
              <div class="image">
                <div class="consumptionbox" v-if="flowData.consumption.status == 0" style="opacity:0.15"></div>
                <div class="consumptionbox" v-else></div>
                <!-- <img v-if="flowData.consumption.status" :src="imgPath.consumption" /> -->
                <!-- <img v-else src="@/assets/img/consumption_disable.png" /> -->
              </div>
              <!-- 负载名称 -->
              <!-- <span class="name" v-if="flowData.consumption.status == 0" style="opacity:0.5">{{ $t('device.consumption')
              }}</span>
              <span class="name" v-else>{{ $t('device.consumption') }}</span> -->
            </div>
            <!-- 能流################################### -->
            <!-- 光伏板 -->
            <div class="value-generation" :class="{ enable: flowData.generation.status === 1, negative: flowData.generation.status === 1 }">
              <!-- <div class="data">{{ flowData.generation.val }}</div> -->
              <flow-line :data="flowData.generation" type="generationLine"></flow-line>
            </div>
            <!-- ===继电器relay==================== -->
            <!-- 模拟各种情况 -->
            <!-- 111{{flowData.relay&&flowData.relay.obj}} -->
            <!-- 222{{flowData.relay&&flowData.relay.status}} -->
            <div
              v-if="flowData.relay && flowData.relay.length > 0"
              class="value-relay"
              :class="{
                electric: flowData.relay && flowData.relay.status === 1,
                undirected: flowData.relay && flowData.relay.status === 0,
                undirectedLine: flowData.relay && flowData.relay.status === -1,
                undirectedLight: flowData.relay && flowData.relay.status === 2
              }"
            >
              <div class="data">
                <!-- 原值 -->
                <!-- {{flowData.relay.val}} -->
                <!-- 增加样式 -->
                <span>{{ flowData.relay.val }}</span>
                <!-- <span class="valUnitStyle">
              /\d+(\.\d+)?/
              <span class="valStyle">{{(flowData.relay.val).match(/^[+-]?\d+(\.\d+)?$/) ? (flowData.relay.val).match(/^[+-]?\d+(\.\d+)?$/)[0] : ''}}</span>
              <span class="unitStyle">{{(flowData.relay.val).match(/[A-Za-z]+/) ? (flowData.relay.val).match(/[A-Za-z]+/)[0] : ''}}</span>
            </span> -->
              </div>
              <!-- <div 
            v-if="flowData.relay.leftStatus==1"
            class="label"
          >
            <div>{{flowData.relay.leftLabel}}</div>
            <div>{{flowData.relay.leftVal}}</div>
          </div> -->
            </div>
            <!-- ===继电器relay==================== -->
            <!-- 电网 -->
            <div
              class="value-grid"
              :class="{
                enable: flowData.grid.status === 1 || flowData.grid.status === -1,
                positive: flowData.grid.status === 1,
                negative: flowData.grid.status === -1
              }"
            >
              <flow-line :data="flowData.grid" type="gridLine"></flow-line>
              <!-- <div class="data">{{ flowData.grid.val }}</div> -->
            </div>
            <!-- 电池 -->
            <div
              class="value-battery"
              :class="{
                enable: flowData.battery.status === -1 || flowData.battery.status === 1,
                positive: flowData.battery.status === -1,
                negative: flowData.battery.status === 1
              }"
            >
              <div class="data">
                <flow-line :data="flowData.battery" type="batteryLine"></flow-line>
                <!-- <div>{{ flowData.battery.val[0] }}</div>
                <div v-if="flowData.battery.val[1]">{{ flowData.battery.val[1] }}</div> -->
              </div>
            </div>
            <!-- ===发电机alternator==================== -->
            <!-- 模拟各种情况 -->
            <div
              v-if="flowData.alternator && flowData.alternator.length > 0"
              class="value-alternator"
              :class="{
                electric: flowData.alternator && flowData.alternator.status === 1,
                undirected: flowData.alternator && flowData.alternator.status === 0,
                undirectedLine: flowData.alternator && flowData.alternator.status === -1,
                undirectedLight: flowData.alternator && flowData.alternator.status === 2
              }"
            >
              <!-- v-if="true" -->
              <div
                class="data"
                v-if="
                  (flowData.alternator && flowData.alternator.status === 1) ||
                    (flowData.alternator && flowData.alternator.status === 0) ||
                    (flowData.alternator && flowData.alternator.status === 2)
                "
              >
                {{ flowData.alternator.val }}
                <!-- <span class="valUnitStyle">
              <span class="valStyle">{{(flowData.alternator.val).match(/^[+-]?\d+(\.\d+)?$/) ? (flowData.alternator.val).match(/^[+-]?\d+(\.\d+)?$/)[0] : ''}}</span>
              <span class="unitStyle">{{(flowData.alternator.val).match(/[A-Za-z]+/) ? (flowData.alternator.val).match(/[A-Za-z]+/)[0] : ''}}</span>
            </span> -->
              </div>
              <div
                class="label"
                :class="{
                  labelNone: flowData.alternator && flowData.alternator.leftStatus == 0,
                  labelLine: flowData.alternator && flowData.alternator.leftStatus == 1
                }"
              >
                <div>
                  <div style="text-align:center;">{{ flowData.alternator.leftLabel }}</div>
                  <div style="text-align:center;">{{ flowData.alternator.leftVal }}</div>
                </div>
              </div>
            </div>
            <!-- ===发电机alternator==================== -->
            <!-- 负载 -->
            <div class="value-consumption" :class="{ enable: flowData.consumption.status === -1, negative: flowData.consumption.status === -1 }">
              <flow-line :data="flowData.consumption" type="consumptionLine"></flow-line>
              <!-- <div class="data">{{ flowData.consumption.val }}</div> -->
            </div>
          </div>
          <div class="scene" v-else>
            <!-- 图标################################### -->
            <div class="generation-container" @click="activeDialog = 'pv_'">
              <div class="image">
                <div class="generationbox" v-if="flowData.generation.status == 0" style="opacity:0.15"></div>
                <div class="generationbox" v-else></div>
                <!-- <img v-if="flowData.generation.status" :src="imgPath.generation" /> -->
                <!-- <img v-else src="@/assets/img/generation_disable.png" /> -->
              </div>
              <!-- 光伏板名称 -->
              <span class="name" v-if="flowData.generation.status == 0" style="opacity:0.5">{{ $t("device.generation") }}</span>
              <span class="name" v-else>{{ $t("device.generation") }}</span>
            </div>

            <!-- ===继电器relay==================== -->
            <!-- @click="activeDialog='pv_'" -->
            <div v-if="flowData.relay && flowData.relay.length > 0" class="relay-container">
              <div class="image">
                <div class="relaybox" v-if="flowData.relay.status == 0" style="opacity:0.15"></div>
                <div class="relaybox" v-else></div>
              </div>
              <!-- 微逆relay -->
              <span class="label" v-if="flowData.relay.status == 0" style="opacity:0.5">{{ $t("device.relay") }}</span>
              <span class="label" v-else>{{ $t("device.relay") }}</span>
            </div>
            <!-- ===继电器relay==================== -->

            <div class="grid-container" @click="activeDialog = 'gd_'">
              <div class="image">
                <div class="gridbox" v-if="flowData.grid.status == 0" style="opacity:0.15"></div>
                <div class="gridbox" v-else></div>
                <!-- <img v-if="flowData.grid.status" :src="imgPath.grid" /> -->
                <!-- <img v-else src="@/assets/img/grid_disable.png" /> -->
              </div>
              <!-- 电网名称 -->
              <span class="name" v-if="flowData.grid.status == 0" style="opacity:0.5">{{ $t("device.grid") }}</span>
              <span class="name" v-else>{{ $t("device.grid") }}</span>
            </div>
            <div class="inverter-container" @click="activeDialog = 'sy_'">
              <div class="image">
                <!-- <div v-if="collEnergyFlaga">
                  <div class="inverterbox" v-if="websockDevideStatus != 1"></div>
                  <div class="inverterbox" v-else style="opacity:0.15"></div>
                </div>
                <div v-else>
                  <div class="inverterbox" v-if="flowData.inverter.status != 1"></div>
                  <div class="inverterbox" v-else style="opacity:0.15"></div>
                </div> -->
                <div>
                  <div class="inverterbox" v-if="flowData.inverter.status != 1"></div>
                  <div class="inverterbox" v-else style="opacity:0.15"></div>
                </div>
              </div>
              <!-- 设备名称 -->
              <!-- <div v-if="collEnergyFlaga">
                  <span class="name" v-if="websockDevideStatus != 1">{{ $t("device.brandDevice") }}</span>
                  <span class="name" v-else style="opacity:0.5">{{ $t("device.brandDevice") }}</span>
                </div>
                <div v-else>
                  <span class="name" v-if="flowData.inverter.status != 1">{{ $t("device.brandDevice") }}</span>
                  <span class="name" v-else style="opacity:0.5">{{ $t("device.brandDevice") }}</span>
                </div> -->
                <div>
                  <span class="name" v-if="flowData.inverter.status != 1">{{ $t("device.brandDevice") }}</span>
                  <span class="name" v-else style="opacity:0.5">{{ $t("device.brandDevice") }}</span>
                </div>
            </div>
            <!-- 单独拿出判断所用图片 -->
            <div class="battery-container" @click="activeDialog = 'bt_'">
              <div class="image" v-if="flowData.battery.status == 0" style="opacity:0.15">
                <img :src="batteryPath.batterys" />
              </div>
              <div class="image" v-else-if="flowData.battery.status == -1">
                <img :src="batteryPath.battery" />
              </div>
              <div class="image" v-else>
                <img :src="batteryPath.batterys" />
              </div>
              <!-- <div>
            <img v-if="flowData.battery.status==-1" :src="batteryPath.battery" />
            <img v-else-if="flowData.battery.status==1" :src="batteryPath.batterys" />
            <img v-else :src="batteryPath.batterys" />
          </div> -->
              <!-- 电池名称 -->
              <span class="name" v-if="flowData.battery.status == 0" style="opacity:0.5">{{ $t("device.battery") }}</span>
              <span class="name" v-else>{{ $t("device.battery") }}</span>
            </div>

            <!-- ===发电机alternator==================== -->
            <!-- @click="activeDialog='pv_'" -->
            <div v-if="flowData.alternator && flowData.alternator.length > 0" class="alternator-container">
              <div class="image">
                <!-- <div class="alternatorbox" v-if="flowData.alternator."></div> -->
                <div class="alternatorbox" v-if="flowData.alternator.status == 0" style="opacity:0.15"></div>
                <div class="alternatorbox" v-else></div>
              </div>
              <!-- 发电机alternator -->
              <span class="label" v-if="flowData.alternator.status == 0" style="opacity:0.5">{{ $t("device.alternator") }}</span>
              <span class="label" v-else>{{ $t("device.alternator") }}</span>
            </div>
            <!-- ===发电机alternator==================== -->

            <div class="consumption-container" @click="activeDialog = 'bc_'">
              <div class="image">
                <div class="consumptionbox" v-if="flowData.consumption.status == 0" style="opacity:0.15"></div>
                <div class="consumptionbox" v-else></div>
                <!-- <img v-if="flowData.consumption.status" :src="imgPath.consumption" /> -->
                <!-- <img v-else src="@/assets/img/consumption_disable.png" /> -->
              </div>
              <!-- 负载名称 -->
              <span class="name" v-if="flowData.consumption.status == 0" style="opacity:0.5">{{ $t("device.consumption") }}</span>
              <span class="name" v-else>{{ $t("device.consumption") }}</span>
            </div>

            <!-- 能流################################### -->
            <!-- 光伏板 -->
            <div class="value-generation" :class="{ enable: flowData.generation.status === 1, negative: flowData.generation.status === 1 }">
              <!-- <div class="value-generation" :class="{enable: flowData.generation.status,negative: flowData.generation.status===1}"> -->
              <div class="data">{{ flowData.generation.val }}</div>
            </div>

            <!-- ===继电器relay==================== -->
            <!-- 模拟各种情况 -->
            <!-- 111{{flowData.relay&&flowData.relay.obj}} -->
            <!-- 222{{flowData.relay&&flowData.relay.status}} -->
            <div
              v-if="flowData.relay && flowData.relay.length > 0"
              class="value-relay"
              :class="{
                electric: flowData.relay && flowData.relay.status === 1,
                undirected: flowData.relay && flowData.relay.status === 0,
                undirectedLine: flowData.relay && flowData.relay.status === -1,
                undirectedLight: flowData.relay && flowData.relay.status === 2
              }"
            >
              <div class="data">
                <!-- 原值 -->
                <!-- {{flowData.relay.val}} -->
                <!-- 增加样式 -->
                <span>{{ flowData.relay.val }}</span>
                <!-- <span class="valUnitStyle">
              /\d+(\.\d+)?/
              <span class="valStyle">{{(flowData.relay.val).match(/^[+-]?\d+(\.\d+)?$/) ? (flowData.relay.val).match(/^[+-]?\d+(\.\d+)?$/)[0] : ''}}</span>
              <span class="unitStyle">{{(flowData.relay.val).match(/[A-Za-z]+/) ? (flowData.relay.val).match(/[A-Za-z]+/)[0] : ''}}</span>
            </span> -->
              </div>
              <!-- <div 
            v-if="flowData.relay.leftStatus==1"
            class="label"
          >
            <div>{{flowData.relay.leftLabel}}</div>
            <div>{{flowData.relay.leftVal}}</div>
          </div> -->
            </div>
            <!-- ===继电器relay==================== -->

            <!-- 电网 -->
            <div
              class="value-grid"
              :class="{
                enable: flowData.grid.status === 1 || flowData.grid.status === -1,
                positive: flowData.grid.status === 1,
                negative: flowData.grid.status === -1
              }"
            >
              <div class="data">{{ flowData.grid.val }}</div>
            </div>
            <!-- 电池 -->
            <div
              class="value-battery"
              :class="{
                enable: flowData.battery.status === -1 || flowData.battery.status === 1,
                positive: flowData.battery.status === -1,
                negative: flowData.battery.status === 1
              }"
            >
              <div class="data">
                <div v-if="batteryFlag=='bt_battery_capacity'">
                  <div class="batterySetPrice">
                    <div v-if="flowData.battery.val[1]">{{ flowData.battery.val[1] }}</div>
                  </div>
                  <div style="text-align: center;" v-if="flowData.battery.val[0]">{{ flowData.battery.val[0] }}</div>
                </div>
                <div v-else>
                  <div v-if="flowData.battery.val[0]">{{ flowData.battery.val[0] }}</div>
                </div>
              </div>
            </div>

            <!-- ===发电机alternator==================== -->
            <!-- 模拟各种情况 -->
            <div
              v-if="flowData.alternator && flowData.alternator.length > 0"
              class="value-alternator"
              :class="{
                electric: flowData.alternator && flowData.alternator.status === 1,
                undirected: flowData.alternator && flowData.alternator.status === 0,
                undirectedLine: flowData.alternator && flowData.alternator.status === -1,
                undirectedLight: flowData.alternator && flowData.alternator.status === 2
              }"
            >
              <!-- v-if="true" -->
              <div
                class="data"
                v-if="
                  (flowData.alternator && flowData.alternator.status === 1) ||
                    (flowData.alternator && flowData.alternator.status === 0) ||
                    (flowData.alternator && flowData.alternator.status === 2)
                "
              >
                {{ flowData.alternator.val }}
                <!-- <span class="valUnitStyle">
              <span class="valStyle">{{(flowData.alternator.val).match(/^[+-]?\d+(\.\d+)?$/) ? (flowData.alternator.val).match(/^[+-]?\d+(\.\d+)?$/)[0] : ''}}</span>
              <span class="unitStyle">{{(flowData.alternator.val).match(/[A-Za-z]+/) ? (flowData.alternator.val).match(/[A-Za-z]+/)[0] : ''}}</span>
            </span> -->
              </div>
              <div
                class="label"
                :class="{
                  labelNone: flowData.alternator && flowData.alternator.leftStatus == 0,
                  labelLine: flowData.alternator && flowData.alternator.leftStatus == 1
                }"
              >
                <div>
                  <div style="text-align:center;">{{ flowData.alternator.leftLabel }}</div>
                  <div style="text-align:center;">{{ flowData.alternator.leftVal }}</div>
                </div>
              </div>
            </div>
            <!-- ===发电机alternator==================== -->

            <!-- 负载 -->
            <div class="value-consumption" :class="{ enable: flowData.consumption.status === -1, negative: flowData.consumption.status === -1 }">
              <div class="data">{{ flowData.consumption.val }}</div>
            </div>
          </div>
        </div>
        <device-param class="section"  @collectionUPEvent="handleCollectionUPEvent" :boardDataJudge.sync="boardDataJudge"
         :deviceInfo="deviceInfo" :deviceParamUpdata="deviceParamUpdata" :collEnergyFlaga="collEnergyFlaga" :mqttDataReceived="mqttDataReceived"></device-param>
         <!-- :websockDevideStatus="websockDevideStatus" -->
      </div>
    </div>
    <!-- 外包裹盒子辅助页面适配 -->

    <device-dialog :visible.sync="activeDialog" :title="activeDialogInfo.title" v-if="activeDialog" :width="'auto'" noFooter class="dialogNew">
      <div class="list" slot="content">
        <!-- <template v-for="item in activeDialogInfo.data">
          <span :key="item.id+item.unit" class="item">
            {{item.par}}
            <span v-if="item.unit">({{item.unit}})</span>
          </span>
          <span :key="item.id+item.val" class="item">{{item.val}}</span>
        </template> -->
        <div class="dataBox">
          <div class="topLine">
            <!-- 参数 -->
            <div class="topName">{{ $t("device.parameter") }}</div>
            <!-- 值 -->
            <div class="topName">{{ $t("device.value") }}</div>
            <div class="topName">{{ $t("device.parameter") }}</div>
            <div class="topName">{{ $t("device.value") }}</div>
          </div>
          <div class="dataContent">
            <template v-for="item in activeDialogInfo.data">
                <div :key="item.id+item.unit" class="item">
                  {{item.par}}
                  <span v-if="item.unit">({{item.unit}})</span>
              </div>
              <div :key="item.id+item.val" class="item">{{item.val}}</div>
            </template>
          </div>
        </div>
      </div>
    </device-dialog>
  </div>
</template>
<script>
import { mapGetters,mapState } from 'vuex';
import deviceDialog from "@/components/dialognew/flowIndex"
import deviceParam from "@/components/paramnew"
import flowLine from "@/components/flowLine"
import config from '@/assets/js/config';
import { initMqttStatistic, mqttStatisticDisconnect, setMqttStatisticCallback, delStatisticNetworkListener } from "./mqttStatistic.js";
// 手动加速采集
import { initMqttEnergyFlow, setMqttEnergyFlowCallback, getAccelerationId, abortMqttEnergyFlow, setMqttEnergyFlowFailCallback } from "./mqttEnergyFlow.js";
export default {
  components: {
    deviceDialog,
    deviceParam,
    flowLine
  },
  data() {
    return {
      flowFlagRiyue:JSON.parse(sessionStorage.getItem('vcodes')||[]).some(item => item === "08"),
      surplusNum:'',
      energyFlowConsumed: false,// 本次手动加速是否已扣除次数（防重复扣除）
      energyFlowFailed: false,// 本次手动加速是否已判定失败（超时后迟到数据不再扣除）
      energyFlowLoading: false,// 手动加速中标记（10秒内禁止重复点击）
      energyFlowTimeoutTimer: null,// 手动加速超时定时器
      collectFastNumFlag: false,// 手动-未启动mqtt服务时展示"能流加速"按钮
      // websockDevideStatus:0,
      collEnergyFlaga: false,//是否走websock逻辑，传给子组件paramnew
      mqttDataReceived: false,//MQTT是否成功推送数据
      boardDataJudge: false,//看板是否有数据判断
      dialogDataJudge: false,//能流弹框是否有数据判断
      deviceParamUpdata:[],//websock更新看板参数
      timerEnergy: "",
      webSocketDevStatusUpdata: "",
      flowData: {
        generation: {
          status: 0,
          val: ""
        },
        grid: {
          status: 0,
          val: ""
        },
        inverter: {
          status: 0,
        },
        battery: {
          status: 0,
          val: []
        },
        consumption: {
          status: 0
        }
      }, //能量流图数据
      dialogData: {
        pv_: {
          title: this.$t("statistic.pv"),
          data: []
        }, // 光伏板
        gd_: {
          title: this.$t("statistic.gd"),
          data: []
        }, // 电网
        sy_: {
          title: this.$t("statistic.sy"),
          data: []
        }, // 逆变器
        bt_: {
          title: this.$t("statistic.bt"),
          data: []
        }, // 电池
        bc_: {
          title: this.$t("statistic.bc"),
          data: []
        }, // 负载
         hl_: {
          title: this.$t("createPlant.hl"),
          data: []
        }, // 家庭负载
        eg_: {
          title: this.$t("device.alternator"),
          data: []
        } // 发电机
      }, // 点击设备弹窗数据
      activeDialog: false,
      batteryFlag: "",
      btStatusImg: {},
      // battery:require(`@/assets/img/general/battery_1disable.png`)
      new19DCAer:{},
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo"
      // skin: "getSkin"
    }),
    activeDialogInfo() {
      if (!this.activeDialog) return null
      return this.dialogData[this.activeDialog]
    },
    judgePathName() {
      let hostname = window.location.hostname
      if (hostname.indexOf("poweringev") != -1) {
        return true
      } else {
        return false
      }
    },
    // imgPath () {
    //   return {
    //     generation: require(`@/assets/img/general/flow_generation_default.png`),//光伏
    //     grid: require(`@/assets/img/general/flow_grid_default.png`),//电网
    //     inverter: require(`@/assets/img/general/flow_inverter_default.png`),//设备
    //     // battery: require(`@/assets/img/general/flow_battery_default.png`),//电池
    //     consumption: require(`@/assets/img/general/flow_consumption_default.png`)//负载
    //   };
    // },
    batteryPath() {
      if (this.btStatusImg.par == "bt_battery_capacity" && this.btStatusImg.unit == "%") {
        if (0 < parseFloat(this.flowData.battery.val[0]) && parseFloat(this.flowData.battery.val[0]) <= 20) {
          return {
            battery: require(`@/assets/img/general/battery_1default.png`),
            batterys: require(`@/assets/img/general/battery_1disable.png`)
          }
        } else if (20 < parseFloat(this.flowData.battery.val[0]) && parseFloat(this.flowData.battery.val[0]) <= 40) {
          return {
            battery: require(`@/assets/img/general/battery_2default.png`),
            batterys: require(`@/assets/img/general/battery_2disable.png`)
          }
        } else if (40 < parseFloat(this.flowData.battery.val[0]) && parseFloat(this.flowData.battery.val[0]) <= 60) {
          return {
            battery: require(`@/assets/img/general/battery_3default.png`),
            batterys: require(`@/assets/img/general/battery_3disable.png`)
          }
        } else if (60 < parseFloat(this.flowData.battery.val[0]) && parseFloat(this.flowData.battery.val[0]) <= 80) {
          return {
            battery: require(`@/assets/img/general/battery_4default.png`),
            batterys: require(`@/assets/img/general/battery_4disable.png`)
          }
        } else if (80 < parseFloat(this.flowData.battery.val[0]) && parseFloat(this.flowData.battery.val[0]) <= 100) {
          return {
            battery: require(`@/assets/img/general/battery_5default.png`),
            batterys: require(`@/assets/img/general/battery_5disable.png`)
          }
        } else {
          return {
            battery: require(`@/assets/img/general/battery_0disable.png`),
            batterys: require(`@/assets/img/general/battery_0disable.png`)
          }
        }
      } else if (this.btStatusImg.par == "bt_battery_capacity" && this.btStatusImg.unit != "%" && this.btStatusImg.status != "0") {
        return {
          battery: require(`@/assets/img/general/battery_5default.png`),
          batterys: require(`@/assets/img/general/battery_5disable.png`)
        }
        // if (this.btStatusImg.unit==undefined&&this.deviceInfo.devcode==2376) {
        //   return {
        //     battery: require(`@/assets/img/general/battery_5default.png`),
        //     batterys:require(`@/assets/img/general/battery_5disable.png`)
        //   };
        // }else if(this.btStatusImg.unit==undefined){
        //   return {
        //     battery: require(`@/assets/img/general/battery_0disable.png`),
        //     batterys:require(`@/assets/img/general/battery_0disable.png`)
        //   };
        // }else{
        //   return {
        //     battery: require(`@/assets/img/general/battery_5default.png`),
        //     batterys:require(`@/assets/img/general/battery_5disable.png`)
        //   };
        // }
      } else if (this.btStatusImg.status == "0") {
        return {
          battery: require(`@/assets/img/general/battery_0disable.png`),
          batterys: require(`@/assets/img/general/battery_0disable.png`)
        }
      } else {
        return {
          battery: require(`@/assets/img/general/battery_5default.png`),
          batterys: require(`@/assets/img/general/battery_5disable.png`)
        }
      }
    },
      ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  watch: {
    deviceInfo: {
      handler() {
        if (this.collEnergyFlaga) {
    
              mqttStatisticDisconnect()
          delStatisticNetworkListener()
        }this.mqttDataReceived = false
        this.boardDataJudge = false
        this.dialogDataJudge = false
        this.collEnergyFlaga = false;
        this.deviceParamUpdata = []
        // 切换设备：清理手动加速采集相关状态和连接
        if (this.energyFlowTimeoutTimer) {
          clearTimeout(this.energyFlowTimeoutTimer);
          this.energyFlowTimeoutTimer = null;
        }
        abortMqttEnergyFlow()
        this.energyFlowLoading = false;
        this.energyFlowConsumed = false;
        this.energyFlowFailed = false;
        this.queryFlowData()
        this.queryDialogData()
        // 判断是否启动webSocket服务
        this.queryCollEnergyFlag();
      },
      deep: true
    }
  },
  created() {
    this.queryData()
    // 判断是否启动webSocket服务
    this.queryCollEnergyFlag()
  },
  beforeDestroy() {
    clearInterval(this.timerEnergy)
    // 清理手动加速超时定时器
    if (this.energyFlowTimeoutTimer) {
      clearTimeout(this.energyFlowTimeoutTimer);
      this.energyFlowTimeoutTimer = null;
    }
    // clearInterval(this.webSocketDevStatusUpdata)
    if (this.collEnergyFlaga) {
      mqttStatisticDisconnect()
      delStatisticNetworkListener()
    }
    // 中止手动加速采集mqtt连接（断开连接+清除重连定时器+移除网络监听）
    abortMqttEnergyFlow()
    // 重置手动加速采集相关状态
    this.energyFlowLoading = false;
    this.energyFlowConsumed = false;
    this.energyFlowFailed = false;
  },
  methods: {
    getMqttEnergyFlow(){
      // 剩余手动加速采集次数不足，提示
      if (!(Number(this.surplusNum) > 0)) {
        this.$message.warning(this.$t("datalogger.Insufficient"));
        return;
      }
      // 加速中，禁止重复点击
      if (this.energyFlowLoading) return;
      this.energyFlowLoading = true;
      // 重置本次手动加速扣除标记（一次加速只扣一次）
      this.energyFlowConsumed = false;
      // 重置本次手动加速失败标记（超时后迟到数据不再扣除次数）
      this.energyFlowFailed = false;
      // 设置手动加速采集消息回调（复用能流数据处理）
      setMqttEnergyFlowCallback((data) => {
        this.handleMqttMessage(data);
        console.log("mqttEnergyFlow data", data)
        // 收到手动加速采集数据：放开按钮限制，清除超时定时器
        this.energyFlowLoading = false;
        if (this.energyFlowTimeoutTimer) {
          clearTimeout(this.energyFlowTimeoutTimer);
          this.energyFlowTimeoutTimer = null;
        }
        // 已判定本次加速失败（超时后迟到的数据），不扣除次数
        if (this.energyFlowFailed) return;
        // 收到手动加速采集数据后触发扣除加速次数（仅扣一次）
        if (!this.energyFlowConsumed) {
          this.energyFlowConsumed = true;
          this.consumeFetchCount();
        }
      });
      // 设置加速请求失败回调（FetchEnergyFlowOnce 返回非0：清除定时器、恢复按钮，模块内部会中止会话）
      setMqttEnergyFlowFailCallback(() => {
        this.energyFlowLoading = false;
        if (this.energyFlowTimeoutTimer) {
          clearTimeout(this.energyFlowTimeoutTimer);
          this.energyFlowTimeoutTimer = null;
        }
        // 标记失败，后续迟到数据不再扣除次数
        this.energyFlowFailed = true;
      });
      // 新建一个独立的mqtt连接用于手动加速采集
      initMqttEnergyFlow({
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
      });
      // 10秒内未收到数据则视为加速失败，不扣除次数，并主动断开加速mqtt连接
      this.energyFlowTimeoutTimer = setTimeout(() => {
        this.energyFlowTimeoutTimer = null;
        this.energyFlowLoading = false;
        // 标记本次手动加速失败，超时后迟到的数据不再扣除次数
        this.energyFlowFailed = true;
        // 中止加速会话：主动断开mqtt连接、清除重连定时器、移除网络监听
        abortMqttEnergyFlow();
        this.$message.warning(this.$t("collectionFrequencyUP.collect_fast_fail"));
      }, 120000);
    },
    // 扣除手动加速采集次数（收到mqtt数据后调用）
    consumeFetchCount(){
      let param={
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
        accelerationId: getAccelerationId(),
      }
      this.$request.postDEVMicroservices('/rqc/api/auth/energyFlow/consumeFetchCount', param).then(res => {
        if (res.code == 0) {
          // 扣除成功后刷新剩余次数
          this.getSurplusNum();
        }
      });
    },
    getSurplusNum(){
      let param={
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
      }
      this.$request.getDEVMicroservices('/rqc/api/auth/energyFlow/getFetchCount', param).then(res => {
        console.log("getFetchCount", res)
        if (res.code == 0) {
          if (res.data) {
            this.surplusNum=res.data.surplusNum
          }else{
            this.surplusNum=''
          }
        }
      });
    },
    // 截断保留两位小数，不四舍五入；0 或空返回空字符串
    floorVal(val) {
      const num = parseFloat(val)
      if (!val || isNaN(num)) return ''
      const str = String(num)
      const dot = str.indexOf('.')
      // 无小数部分，直接返回整数
      if (dot === -1) return str
      // 截断到最多两位（不四舍五入）
      let dec = str.slice(dot + 1, dot + 3)
      // 去掉末尾多余的 0：0.20→0.2，0.00→''（整数）
      dec = dec.replace(/0+$/, '')
      if (dec === '') return str.slice(0, dot)
      return str.slice(0, dot + 1) + dec
    },
    // 判断是否启动webSocket服务
    queryCollEnergyFlag(){
      console.log("523", this.deviceInfo.pn)
      clearInterval(this.timerEnergy)
      // clearInterval(this.webSocketDevStatusUpdata)
      // this.$request
      //   .get("queryCollEnergyFlag", {
      //     pn: this.deviceInfo.pn,
      //   })
      //   .then(res => {
      //     if (res.err == 0&&res.dat) {
      //       this.collEnergyFlaga = true;
      //       this.initMqttConnection();
      //       // this.getUpdataDevstatus()
      //       // this.webSocketDevStatusUpdata = setInterval(() => {
      //       //   this.getUpdataDevstatus()
      //       // }, 10000)
      //       // this.loopQuery()
      //       // this.collEnergyFlaga = false;
      //     }else {
      //       this.loopQuery()
      //       this.collEnergyFlaga = false;
      //     }
      //   }).catch(e => {
      //     this.loopQuery()
      //     this.collEnergyFlaga = false;
      // });
      this.$request.getMicroserDess(`/css/api/auth/web/collectorForDIS/${this.deviceInfo.pn}`).then(res => {
        if (res.code === 0&&res.data.energyFetch>0) {
            this.collEnergyFlaga = true;
            this.collectFastNumFlag = false;
            this.initMqttConnection();
        }else{
            this.loopQuery()
            this.collEnergyFlaga = false;
            // 未启动mqtt服务，获取剩余手动加速采集次数并展示按钮
            this.collectFastNumFlag = true;
            this.getSurplusNum();
            // this.collEnergyFlaga = true;
            // this.initMqttConnection();
        }
      }).catch(() => {
          this.loopQuery()
          this.collEnergyFlaga = false;
          // 请求失败视为未启动mqtt服务
          this.collectFastNumFlag = true;
          this.getSurplusNum();
      });


    },
    initMqttConnection() {
      const config = {
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
      };

      // 设置消息回调
      setMqttStatisticCallback((data) => {
        this.handleMqttMessage(data);
      });

      initMqttStatistic(config);
    },
    handleMqttMessage(redata) {
      console.log("handleMqttMessage2222", redata)
      if (redata.flowDat) {
        console.log("3333333333333", redata.flowDat.status)
        // this.websockDevideStatus = redata.flowDat.status
        this.mqttDataReceived = true;
        this.setFlowData(redata.flowDat, true);
      }
      if (redata.spFlowDat && redata.spFlowDat.pars && this.dialogDataJudge) {
        this.updateValues(this.dialogData, redata.spFlowDat.pars);
      }
      if (redata.queryDeviceParsVos&& redata.queryDeviceParsVos.length > 0  && this.boardDataJudge) {
        console.log("queryDeviceParsVos", redata.queryDeviceParsVos)
        this.deviceParamUpdata = redata.queryDeviceParsVos;
      }
    },
    // // websock连接中，用接口更新储能机状态
    // getUpdataDevstatus(){
    //   if(this.collEnergyFlaga){
    //     let param = {
    //       devcode: this.deviceInfo.devcode,
    //       pn: this.deviceInfo.pn,
    //       devaddr: this.deviceInfo.devaddr,
    //       sn: this.deviceInfo.sn
    //     }
    //     this.$request.get("webQueryDeviceEnergyFlowEs", param).then(res => {
    //       if (res.err === 0) {
    //         this.websockDevideStatus = res.dat.status
    //         // this.$set(this.flowData.inverter, 'websockDevideStatus', res.dat.status);
    //       }
    //     })
    //   }
    // },
    updateValues(A, B) {
          // 遍历B中的每个类别（pv_, sy_, by_等）
          for (let category in B) {
              if (A[category]&&B[category]) {
                  // 获取A和B中当前类别的数组
                  let AItems = A[category].data ;
                  let BItems = B[category];
                  // 遍历B中的每一项
                  BItems.forEach(bItem => {
                      // 在A中找到具有相同id的项并更新其val属性
                      let aItem = AItems.find(a => a.id === bItem.id);
                      if (aItem) {
                          // if (bItem.val == Number) {
                          //   aItem.val = parseFloat(bItem.val)
                          // } else {
                          //   aItem.val = bItem.val;
                          // }
                          aItem.val = bItem.val;
                      }
                  });
              }
          }
      },
    handleCollectionUPEvent(val){
      this.$emit('collectionUPEvent', val);
    },
    // 查询页面数据
    queryData() {
      this.queryFlowData()
      this.queryDialogData()
      // this.loopQuery()
    },
    loopQuery() {
      this.timerEnergy = setInterval(() => {
        this.queryFlowData()
        this.queryDialogData()
      }, 60000)
    },
    // 查询弹窗数据
    queryDialogData() {
      this.dialogData={
        pv_: {
          title: this.$t("statistic.pv"),
          data: []
        }, // 光伏板
        gd_: {
          title: this.$t("statistic.gd"),
          data: []
        }, // 电网
        sy_: {
          title: this.$t("statistic.sy"),
          data: []
        }, // 逆变器
        bt_: {
          title: this.$t("statistic.bt"),
          data: []
        }, // 电池
        bc_: {
          title: this.$t("statistic.bc"),
          data: []
        }, // 负载
        hl_: {
          title: this.$t("createPlant.hl"),
          data: []
        }, // 家庭负载
        eg_: {
          title: this.$t("device.alternator"),
          data: []
        } // 发电机
      }
      let param = {
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        devaddr: this.deviceInfo.devaddr,
        sn: this.deviceInfo.sn,
        i18n: this.$lang.currentLang
      }
       let url = this.isMicroService ? "/ppe/api/auth/web/querySPDeviceLastData" : "querySPDeviceLastData";
      this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
          let pars = res[this.resData].pars;
          for (let key in pars) {
            if (this.dialogData[key]) {
              pars[key].forEach(element => {
                if (element.val == Number) {
                  element.val = parseFloat(element.val)
                } else {
                  element.val
                }
              })
              this.dialogData[key].data = pars[key]
            }
          }
          this.dialogDataJudge = true
        }
      })
    },
    // 查询能量流图数据
    queryFlowData() {
      this.batteryFlag=""
      let param = {
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        devaddr: this.deviceInfo.devaddr,
        sn: this.deviceInfo.sn
      }
        let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceEnergyFlow" : "webQueryDeviceEnergyFlowEs";
        // info.Loading = true;
        this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
          this.setFlowData(res[this.resData])
        }else{
          this.flowData = {
            generation: {
              status: 0,
              val: ""
            },
            grid: {
              status: 0,
              val: ""
            },
            inverter: {
              status: 0,
              label: ""
            },
            battery: {
              status: 0,
              val: []
            },
            consumption: {
              status: 0,
              val: ""
            }
          }
        }
      })
    },
    setFlowData(data,websock){
          
          // console.log("【data.bt_status[0]】", data.bt_status[0]);
          // 负载
          // console.log("【计算1】", data.bc_status[0].val);
          // console.log("【计算2】", this.$filter.formatNum(data.bc_status[0].val, 4));
          // console.log("【计算3】", this.$filter.formatNum(data.bc_status[0].val, 4)*1000 + 'W');
          this.flowData = {
            // 原
            // generation: {
            //   status: data.pv_status[0].status,
            //   val: data.pv_status[0].unit
            //     ? this.$filter.formatNum(data.pv_status[0].val, 2) +
            //       data.pv_status[0].unit
            //     : ""
            // },
            // 单位优化(kW/W)
            generation: {
              status: data.pv_status[0].status,
              val: data.pv_status[0].unit
                ? data.pv_status[0].unit == "kW"
                  ? data.pv_status[0].val >= 1
                    ? parseFloat(this.$filter.formatNum(data.pv_status[0].val, 2)) + data.pv_status[0].unit
                    : parseFloat(this.$filter.formatNum(data.pv_status[0].val * 1000, 2)) + "W"
                  : // this.$filter.formatNum(data.pv_status[0].val, 2) + data.pv_status[0].unit
                  data.pv_status[0].val >= 1000
                  ? parseFloat(this.$filter.formatNum(data.pv_status[0].val / 1000, 2)) + "kW"
                  : parseFloat(this.$filter.formatNum(data.pv_status[0].val, 2)) + data.pv_status[0].unit
                : ""
            },
            // 原
            // grid: {
            //   status: data.gd_status[0].status,
            //   val: data.gd_status[0].unit
            //     ? this.$filter.formatNum(data.gd_status[0].val, 2) +
            //       data.gd_status[0].unit
            //     : ""
            // },
            // 单位优化(kW/W)
            grid: {
              status: data.gd_status[0].status,
              val: data.gd_status[0].unit
                ? data.gd_status[0].unit == "kW"
                  ? data.gd_status[0].val > 0
                    ? data.gd_status[0].val >= 1
                      ? parseFloat(this.$filter.formatNum(data.gd_status[0].val, 2)) + data.gd_status[0].unit
                      : parseFloat(this.$filter.formatNum(data.gd_status[0].val * 1000, 2)) + "W"
                    : data.gd_status[0].val <= -1
                    ? parseFloat(this.$filter.formatNum(data.gd_status[0].val, 2)) + data.gd_status[0].unit
                    : parseFloat(this.$filter.formatNum(data.gd_status[0].val * 1000, 2)) + "W"
                  : data.gd_status[0].val > 0
                  ? data.gd_status[0].val < 1000
                    ? parseFloat(this.$filter.formatNum(data.gd_status[0].val, 2)) + data.gd_status[0].unit
                    : parseFloat(this.$filter.formatNum(data.gd_status[0].val / 1000, 2)) + "kW"
                  : data.gd_status[0].val > -1000
                  ? parseFloat(this.$filter.formatNum(data.gd_status[0].val, 2)) + data.gd_status[0].unit
                  : parseFloat(this.$filter.formatNum(data.gd_status[0].val / 1000, 2)) + "kW"
                : // (
                  //   data.gd_status[0].val>=1 ?
                  //   this.$filter.formatNum(data.gd_status[0].val, 2) + data.gd_status[0].unit
                  //   :
                  //   this.$filter.formatNum(data.gd_status[0].val, 2)*1000 + 'W'
                  // )
                  // :
                  // // this.$filter.formatNum(data.gd_status[0].val, 2) + data.gd_status[0].unit
                  // (
                  //   data.gd_status[0].val>=1000 ?
                  //   this.$filter.formatNum(data.gd_status[0].val, 2)/1000 + 'kW'
                  //   :
                  //   this.$filter.formatNum(data.gd_status[0].val, 2) + data.gd_status[0].unit
                  // )
                  ""
            },

            //
            inverter: {
              status: data.status,
              // 未使用，已注释
              // label: this.$filter.deviceType[data.brand].label
            },

            // 原
            // battery: {
            //   status: data.bt_status[0].status,
            //   val: data.bt_status.reduce((result, item) => {
            //     item.unit &&
            //       result.push(this.$filter.formatNum(item.val, 2) + item.unit);
            //     return result;
            //   }, [])
            // },
            // 单位优化(kW/W)
            battery: {
              status: data.bt_status[0].status,
              val: data.bt_status.reduce((result, item) => {
                if (item.par=="bt_battery_capacity") {
                  this.batteryFlag=item.par
                }
                // 当返回数据单位为kW时
                if (item.unit == "kW") {
                  if (item.val > 0) {
                    item.val >= 1
                      ? result.push(parseFloat(this.$filter.formatNum(item.val, 2)) + item.unit)
                      : result.push(parseFloat(this.$filter.formatNum(item.val * 1000, 2)) + "W")
                  } else {
                    item.val <= -1
                      ? result.push(parseFloat(this.$filter.formatNum(item.val, 2)) + item.unit)
                      : result.push(parseFloat(this.$filter.formatNum(item.val * 1000, 2)) + "W")
                  }
                  // item.val>1||item.val<=-1 ?
                  // result.push(this.$filter.formatNum(item.val, 2) + item.unit)
                  // :
                  // result.push(this.$filter.formatNum(item.val, 2)*1000 + 'W')
                }
                // 当返回数据单位为W时
                else if (item.unit == "W") {
                  if (item.val >= 0) {
                    item.val >= 1000
                      ? result.push(parseFloat(this.$filter.formatNum(item.val / 1000, 2)) + "kW")
                      : result.push(parseFloat(this.$filter.formatNum(item.val, 2)) + item.unit)
                  } else {
                    item.val <= -1000
                      ? result.push(parseFloat(this.$filter.formatNum(item.val / 1000, 2)) + "kW")
                      : result.push(parseFloat(this.$filter.formatNum(item.val, 2)) + item.unit)
                  }
                  // item.unit && result.push(this.$filter.formatNum(item.val, 2) + item.unit);
                  // item.val>=1000||item.val<=-1000 ?
                  // result.push(this.$filter.formatNum(item.val, 2)/1000 + 'kW')
                  // :
                  // result.push(this.$filter.formatNum(item.val, 2) + item.unit)
                }
                // 其它
                else {
                  if (item.status == 0 || item.status == 1 || item.status == -1 || item.status == 2) {
                    if (item.par == "bt_battery_capacity") {
                      if (item.unit == "%") {
                        item.unit && result.push(parseFloat(this.$filter.formatNum(item.val, 0)) + item.unit)
                      } else if (item.unit != "%" && item.unit != undefined) {
                        item.unit && result.push(parseFloat(this.$filter.formatNum(item.val, 2)) + item.unit)
                      } else {
                        result.push(parseFloat(this.$filter.formatNum(item.val, 2)))
                      }
                    } else {
                      if (item.unit) {
                        item.unit && result.push(parseFloat(this.$filter.formatNum(item.val, 2)) + item.unit)
                      } else {
                        result.push(parseFloat(this.$filter.formatNum(item.val, 2)))
                      }
                    }
                  } else {
                    item.val = ""
                  }

                  // item.unit && result.push(this.$filter.formatNum(item.val, 0) + item.unit);
                }
                return result
              }, [])
            },

            // 原
            // consumption: {
            //   status: data.bc_status[0].status,
            //   val: data.bc_status[0].unit
            //     ? this.$filter.formatNum(data.bc_status[0].val, 2) +
            //       data.bc_status[0].unit
            //     : ""
            // },
            // 单位优化(kW/W)
            consumption: {
              status: data.bc_status[0].status,
              val: data.bc_status[0].unit
                ? data.bc_status[0].unit == "kW"
                  ? data.bc_status[0].val >= 1
                    ? parseFloat(this.$filter.formatNum(data.bc_status[0].val, 2)) + data.bc_status[0].unit
                    : parseFloat(this.$filter.formatNum(data.bc_status[0].val * 1000, 2)) + "W"
                  : // this.$filter.formatNum(data.bc_status[0].val, 2) + data.bc_status[0].unit
                  data.bc_status[0].val >= 1000
                  ? parseFloat(this.$filter.formatNum(data.bc_status[0].val / 1000, 2)) + "kW"
                  : parseFloat(this.$filter.formatNum(data.bc_status[0].val, 2)) + data.bc_status[0].unit
                : ""
            },

            // 发电机(单位优化kW/W)==========
            // alternator: {
            //   length: 1,
            //   // 发电机流向：1发电 | 0无方向 | -1无向有线 | 2点亮无向
            //   // {"par":"motor_output_power","val":"0.00","unit":"kW","status":2}
            //   status: 2,
            //   val: '1.2kW',
            //   // {"par":"Signal","val":"off","status":0}
            //   leftLabel: "Signal",
            //   leftVal: "off",
            //   leftStatus: 1,
            // },
            alternator: {
              // obj: data.mt_status,
              length: (data.mt_status && data.mt_status.length) || 0,
              //
              leftLabel: (data.mt_status && data.mt_status.length > 0 && data.mt_status[0].par) || "",
              leftVal: (data.mt_status && data.mt_status.length > 0 && data.mt_status[0].val) || "",
              leftStatus: data.mt_status && data.mt_status.length > 0 && data.mt_status[0].status,
              //
              status: data.mt_status && data.mt_status.length > 0 && data.mt_status[1] && data.mt_status[1].status,
              val:
                data.mt_status && data.mt_status.length > 0 && data.mt_status[1] && data.mt_status[1].unit
                  ? data.mt_status[1].unit == "kW"
                    ? data.mt_status[1].val >= 1
                      ? parseFloat(this.$filter.formatNum(data.mt_status[1].val, 2)) + data.mt_status[1].unit
                      : parseFloat(this.$filter.formatNum(data.mt_status[1].val * 1000, 2)) + "W"
                    : // this.$filter.formatNum(data.mt_status[1].val, 2) + data.mt_status[1].unit
                    data.mt_status[1].val >= 1000
                    ? parseFloat(this.$filter.formatNum(data.mt_status[1].val / 1000, 2)) + "kW"
                    : parseFloat(this.$filter.formatNum(data.mt_status[1].val, 2)) + data.mt_status[1].unit
                  : ""
            },

            // 微逆(单位优化kW/W)==========
            // relay: {
            //   length: 0,
            //   // 微逆流向：1发电 | 0无方向 | -1暂未定义 | 2点亮无向
            //   status: 1,
            //   val: '500W'
            // },
            relay: {
              // obj: data.mi_status,
              length: (data.mi_status && data.mi_status.length) || 0,
              //
              status: data.mi_status && data.mi_status.length > 0 && data.mi_status[0].status,
              val:
                data.mi_status && data.mi_status.length > 0 && data.mi_status[0].unit
                  ? data.mi_status[0].unit == "kW"
                    ? data.mi_status[0].val >= 1
                      ? parseFloat(this.$filter.formatNum(data.mi_status[0].val, 2)) + data.mi_status[0].unit
                      : parseFloat(this.$filter.formatNum(data.mi_status[0].val * 1000, 2)) + "W"
                    : // this.$filter.formatNum(data.mi_status[0].val, 2) + data.mi_status[0].unit
                    data.mi_status[0].val >= 1000
                    ? parseFloat(this.$filter.formatNum(data.mi_status[0].val / 1000, 2)) + "kW"
                    : parseFloat(this.$filter.formatNum(data.mi_status[0].val, 2)) + data.mi_status[0].unit
                  : ""
            },

          }
          this.btStatusImg = data.bt_status[0]
          this.new19DCAer = data
          console.log(this.flowData,this.new19DCAer,'this.flowData')
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.deviceStatisticNew {
  .section {
    border-radius: 0;
    border: none;
    background: #202d35;
    color: #ffffff;
    box-shadow: none;
    // [XM调整布局]
    overflow: hidden;
  }

  .flow {
    position: relative;
    padding: 5px;
    margin-top: 15px;
    flex: 1;
    // display: flex;
    // // flex-direction: column;
    // justify-content: center;
    // align-items: center;

    background: #202d35;
    // background: gray;

    margin-right: 12px;

    // overflow: auto;

    // 溢出滚动时右下角方块(遮挡)
    // .corner {
    //   width: 10px;
    //   height: 10px;
    //   position: absolute;
    //   right: 0px;
    //   bottom: 0px;
    //   // background: #202D35;
    //   background: red;
    // }

    .title {
      .sc(28px, #000);
      text-align: center;
      margin-bottom: 5px;
      height: 0px;
    }

    .scenecustom {
      flex: 1;
      // position: absolute;
      position: relative;

      // 原
      // min-height: 650px;
      // max-height: 650px;
      // min-width: 982px;
      // max-width: 982px;
      // 新
      // min-height: 616px;
      // max-height: 616px;
      // min-width: 1000px;
      // max-width: 1000px;
      width: 748px;
      height: 680px; //650?
      // background: #74818a;

      // 居中
      margin: auto;
      // top: 100px;//0!
      top: 0px; //0!
      left: 0;
      right: 0;
      bottom: 0;

      .container(@horizontal, @vertical) {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 2;

        .image {
          font-size: 0;
          transition: transform 0.2s linear;
          position: relative;

          &::before {
            transition: all 0.2s linear;
            content: "";
            opacity: 0;
            position: absolute;
            top: -10px;
            left: -10px;
            right: -10px;
            bottom: -10px;
            border-radius: 50%;
            z-index: -1;
          }

          img {
            width: 100px;
            height: 100px;
          }
        }

        // &:hover {
        //   .image {
        //     transform: translate(5px * @horizontal, 5px * @vertical);
        //     &::before {
        //       opacity: 1;
        //       box-shadow: -4px * @horizontal -4px * @vertical 6px 5px @borderColor;
        //     }
        //   }
        // }
        .name {
          line-height: 20px;
          .sc(16px, #ffffff);
          // margin-top: 10px;
          margin-top: -32px;
          // 处理PNG边距导致文字看似不居中
          margin-right: 12px;
        }
      }

      .generation-container {
        .container(-1, -1);
        top: 45px;
        // left: 50px;
        left: 0px;
        z-index: 2;
        .generationbox {
          width: 207px;
          height: 146px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/newFlowImg/generation.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center 0px; //-40px

          &:hover {
            background-image: url("../../../../assets/img/newFlowImg/generation.png");
            transform: scale(1.1);
          }
        }
      }
      .grid-container {
        .container(1, -1);
        top: 45px;
        // right: 50px;
        right: 6px;

        .gridbox {
          // 212
          // W252px/H242px
          width: 207px;
          height: 146px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/newFlowImg/grid.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-position: center;
          background-position: center 0px; //-40px

          &:hover {
            background-image: url("../../../../assets/img/newFlowImg/grid.png");
            transform: scale(1.1);
          }
        }

        // .name {
        //   margin-top: -70px;
        // }
      }

      .inverter-container {
        .container(0, -1);
        top: 45%;
        left: 50%;
        transform: translate(-50%, -57px);

        .inverterbox {
          // 212
          // W252px/H242px
          width: 207px;
          height: 146px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/newFlowImg/interver.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;

          &:hover {
            transform: scale(1.1);
          }
        }
      }

      .battery-container {
        .container(-1, 1);
        // bottom: 15px;
        bottom: 50px; //0!
        // left: 50px;
        left: 0px;

        .batterybox {
          // 212
          // W252px/H242px
          width: 207px;
          height: 146px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/newFlowImg/battery.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;

          &:hover {
            transform: scale(1.1);
          }
        }

        // .image {
        //   // 212
        //   // W252px/H242px
        //   width: 195px;
        //   height: 212px;
        //   // width: 15vw;
        //   // height: 15vw;
        //   background-image: url('../../../../assets/img/general/flow_null_default.png');
        //   background-repeat: no-repeat;
        //   background-size: 100% 100%;
        //   background-position: center;
        //   // padding-top: 60px;
        //   padding-top: 65px; //75!
        //   text-align: center;

        //   img {
        //     width: 77px;
        //     height: 69px;
        //     margin-right: 12px;
        //     // width: 5vw;
        //     // height: 4vw;
        //     // margin-right: 1vw;
        //   }

        //   &:hover {
        //     background-image: url('../../../../assets/img/general/flow_null_hover.png');

        //     img {
        //       margin-right: 5px;
        //     }
        //   }
        // }
      }

      .consumption-container {
        .container(1, 1);
        // bottom: 15px;
        bottom: 50px; //0!
        // right: 38px;
        right: 0px;

        .consumptionbox {
          // 212
          // W252px/H242px
          width: 207px;
          height: 146px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/newFlowImg/consumption.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;

          &:hover {
            transform: scale(1.1);
          }
        }
      }

      // 发电机alternator=============
      .alternator-container {
        .container(0, -1);
        bottom: -10px;
        left: 50%;
        margin-left: -4px;
        transform: translate(-50%, -57px);

        .alternatorbox {
          // 原207*146（0.85）=>176*124
          width: 176px;
          height: 124px;
          background-image: url("../../../../assets/img/general/flow_alternator_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;

          &:hover {
            background-image: url("../../../../assets/img/general/flow_alternator_hover.png");
          }
        }

        .label {
          margin-top: 5px;
          margin-left: -10px;
        }
      }

      // 发电机alternator=============
      // 继电器relay==================
      .relay-container {
        .container(0, -1);
        top: 108px;
        left: 50%;
        margin-left: -4px;
        transform: translate(-50%, -57px);

        .relaybox {
          // 原207*146（0.85）=>176*124
          width: 176px;
          height: 124px;
          background-image: url("../../../../assets/img/general/flow_relay_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;

          &:hover {
            background-image: url("../../../../assets/img/general/flow_relay_hover.png");
          }
        }

        .label {
          margin-top: 5px;
          margin-left: -4px;
        }
      }

      // 继电器relay==================
      // [原]
      // .value(@positive, @position) {
      //   position: absolute;
      //   &:not(.enable) {
      //     background: repeating-linear-gradient(
      //       45deg * @positive,
      //       #d7d7d7 0,
      //       #d7d7d7 30%,
      //       #eaf0f2 30%,
      //       #eaf0f2 50%
      //     );
      //     background-size: 30px 30px;
      //   }
      //   &.enable {
      //     background: repeating-linear-gradient(
      //       45deg * @positive,
      //       #1890ff 0,
      //       #1890ff 30%,
      //       #eaf0f2 30%,
      //       #eaf0f2 50%
      //     );
      //     background-size: 30px 30px;
      //     .data {
      //       color: #1890ff;
      //     }
      //   }
      //   &.positive {
      //     @keyframes positive {
      //       100% {
      //         background-position: -100%;
      //       }
      //     }
      //     animation: positive 18s linear infinite;
      //   }
      //   &.negative {
      //     @keyframes negative {
      //       100% {
      //         background-position: 100%;
      //       }
      //     }
      //     animation: negative 18s linear infinite;
      //   }
      //   .data {
      //     height: 100%;
      //     background: #202D35;
      //     display: grid;
      //     justify-content: center;
      //     justify-items: center;
      //     align-items: @position;
      //     padding: 10px;
      //     font-size: 20px;
      //     color: #d7d7d7;
      //   }
      // }
      // [新]
      // .value(-1, flex-end)
      .value(@positive, @position) {
        position: absolute;

        &:not(.enable) {
          background: repeating-linear-gradient(45deg * @positive, #d7d7d7 0, #d7d7d7 30%, #eaf0f2 30%, #eaf0f2 50%);
          background-size: 30px 30px;
        }

        &.enable {
          background: repeating-linear-gradient(45deg * @positive, #1890ff 0, #1890ff 30%, #eaf0f2 30%, #eaf0f2 50%);
          background-size: 30px 30px;

          .data {
            color: #1890ff;
          }
        }

        &.positive {
          @keyframes positive {
            100% {
              background-position: -100%;
            }
          }

          animation: positive 18s linear infinite;
        }

        &.negative {
          @keyframes negative {
            100% {
              background-position: 100%;
            }
          }

          animation: negative 18s linear infinite;
        }

        .data {
          height: 100%;
          background: #202d35;
          display: grid;
          justify-content: center;
          justify-items: center;
          align-items: @position;
          padding: 10px;
          font-size: 20px;
          color: #d7d7d7;
        }
      }

      // 光伏板(-1)
      .value-generation {
        // [原]
        // .value(-1, flex-end);
        // [新]..........
        position: absolute;
        // mw310/mh100
        min-height: 130px;
        max-height: 130px;
        min-width: 217px;
        max-width: 217px;

        // &:not(.enable) {
        //   transform: rotateX(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        //   background-size: 100% 100%;
        // }

        // &.enable {
        //   background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;

        //   // background-size: 100% 100%;
        //   .data {
        //     color: #1890ff;
        //     // transform: rotateX(180deg);
        //   }
        // }

        // // [积极-出](-1)
        // &.positive {
        //   transform: rotateX(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        // }

        // // [消极-进](-1)
        // &.negative {
        //   transform: rotateX(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        // }

        // // 可封装
        // .data {
        //   transform: rotateX(180deg);
        //   height: 100%;
        //   // background: #202D35;
        //   background: transparent;
        //   display: grid;
        //   justify-content: center;
        //   justify-items: center;
        //   // align-items: @position;
        //   align-items: flex-end;
        //   padding: 30px;
        //   font-size: 20px;
        //   color: #d7d7d7;
        // }

        // ..............
        // top: 165px;
        top: 205px; //228!
        right: calc(~"50% + 60px");
        bottom: calc(~"50% + 20px");
        // left: 132px;
        left: 80px; //107
        border-bottom-left-radius: 10px;
        // padding: 0 0 5px 5px;
        padding: 0px;

        .data {
          border-bottom-left-radius: 10px;
        }
      }

      // 电网(1)
      .value-grid {
        // [原]
        // .value(1, flex-end);
        // [新]..........
        position: absolute;
        // mw310/mh100
        min-height: 130px;
        max-height: 130px;
        min-width: 217px;
        max-width: 217px;
        // &:not(.enable) {
        //   transform: rotate(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        //   // background-size: 100% 100%;
        // }

        // &.enable {
        //   background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;

        //   // background-size: 100% 100%;
        //   .data {
        //     color: #1890ff;
        //     transform: rotate(180deg);
        //   }
        // }

        // // [积极-出](1)
        // &.positive {
        //   transform: rotate(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        // }

        // // [消极-进](1)
        // &.negative {
        //   transform: rotate(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        // }

        //可封装
        .data {
          // transform: rotate(180deg);
          height: 100%;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-end;
          padding: 30px;
          font-size: 20px;
          color: #d7d7d7;
        }

        // ..............
        // top: 165px;
        top: 205px; //228!
        right: 132px;
        bottom: calc(~"50% + 20px");
        left: calc(~"50% + 70px");
        border-bottom-right-radius: 10px;
        padding: 0 5px 5px 0;

        .data {
          border-bottom-right-radius: 10px;
        }
      }

      // 电池(1)
      .value-battery {
        // [原]
        margin-top: 36px;
        // .value(1, flex-start);
        // [新]..........
        position: absolute;
        // mw310/mh100
        min-height: 130px;
        max-height: 130px;
        min-width: 217px;
        max-width: 217px;

        // &:not(.enable) {
        //   // transform: rotateX(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        //   // background-size: 100% 100%;
        // }
        // &.enable {
        //   background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;

        //   // background-size: 100% 100%;
        //   .data {
        //     color: #1890ff;
        //     // transform: rotateX(180deg);
        //   }
        // }

        // // [积极-出](1)
        // &.positive {
        //   // transform: rotateX(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        // }

        // // [消极-进](1)
        // &.negative {
        //   // transform: rotateX(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        // }

        // //可封装
        // .data {
        //   // transform: rotateX(180deg);
        //   height: 100%;
        //   // background: #202D35;
        //   background: transparent;
        //   display: grid;
        //   justify-content: center;
        //   justify-items: center;
        //   // align-items: @position;
        //   align-items: flex-start;
        //   padding: 25px;
        //   font-size: 20px;
        //   color: #d7d7d7;
        // }

        // ..............
        // top: calc(~"50% + 20px");
        top: calc(~"48% + 0px");
        right: calc(~"50% + 60px");
        bottom: 136px;
        // left: 132px;
        left: 80px; //107!
        border-top-left-radius: 10px;
        padding: 5px 0 0 5px;

        .data {
          border-top-left-radius: 10px;
        }
      }

      // 负载(-1)
      .value-consumption {
        // [原]
        margin-top: 36px;
        // .value(-1, flex-start);
        // [新]..........
        position: absolute;
        // mw310/mh100
        min-height: 130px;
        max-height: 130px;
        min-width: 217px;
        max-width: 217px;

        // &:not(.enable) {
        //   transform: rotateY(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        //   // background-size: 100% 100%;
        // }

        // &.enable {
        //   background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;

        //   // background-size: 100% 100%;
        //   .data {
        //     color: #1890ff;
        //     transform: rotateY(180deg);
        //   }
        // }

        // // [积极-出](-1)
        // &.positive {
        //   transform: rotateY(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        // }

        // // [消极-进](-1)
        // &.negative {
        //   transform: rotateY(180deg);
        //   background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
        //     url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        // }

        // // 可封装
        // .data {
        //   transform: rotateY(180deg);
        //   height: 100%;
        //   // background: #202D35;
        //   background: transparent;
        //   display: grid;
        //   justify-content: center;
        //   justify-items: center;
        //   // align-items: @position;
        //   align-items: flex-start;
        //   padding: 25px;
        //   font-size: 20px;
        //   color: #d7d7d7;
        // }

        // ..............
        // top: calc(~"50% + 20px");
        top: calc(~"48% + 0px");
        right: 132px;
        bottom: 136px;
        left: calc(~"50% + 70px");
        border-top-right-radius: 10px;
        padding: 5px 5px 0 0;

        .data {
          border-top-right-radius: 10px;
        }
      }

      // 继电器relay==========
      .value-relay {
        position: absolute;
        width: 30px;
        height: 70px;
        max-height: 70px;

        // -----------------------------------------------------
        // 轨道
        // background: url('../../../../assets/img/general/Flow_Device_Static_Right.png') no-repeat 0px 0px;
        // 轨道+流动
        // background: url('../../../../assets/img/general/Flow_Device_Enter.gif') no-repeat 6px 7px,
        //     url('../../../../assets/img/general/Flow_Device_Static_Right.png') no-repeat 0px 0px;
        // 流动
        // background: url('../../../../assets/img/general/Flow_Device_Up.gif') no-repeat 6px 7px;
        // -----------------------------------------------------
        // 微逆流向：1发电 | 0无方向 | -1暂未定义 | 2点亮无向
        &.electric {
          background: url("../../../../assets/img/general/Flow_Device_Down.gif") no-repeat 8px 0px,
            url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }

        // &.undirected {
        // }
        // &.undeclared {
        // }
        &.undirectedLight {
          // background: url('../../../../assets/img/general/Flow_Device_StaticIn_Vertical.png') no-repeat 12px 0px,
          //   url('../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png') no-repeat 0px 0px;
          background: url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }

        // -----------------------------------------------------

        // 可封装
        .data {
          // transform: rotateX(180deg);
          height: 100%;
          line-height: 70px;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-end;
          padding: 0px;
          padding-left: 35px;
          font-size: 20px;
          color: #d7d7d7;

          position: absolute;
          left: 0px;
          top: 0px;
        }

        // ..............
        // // top: 165px;
        // top: 205px;//228!
        // right: calc(~"50% + 60px");
        // bottom: calc(~"50% + 20px");
        // // left: 132px;
        // left: 50%;//107

        top: 264px;
        left: 49%;
        transform: translate(-50%, -57px);

        // border-bottom-left-radius: 10px;
        // padding: 0 0 5px 5px;
        padding: 0px;
        // .data {
        //   border-bottom-left-radius: 10px;
        // }
      }

      // 发电机alternator==========
      .value-alternator {
        position: absolute;
        width: 30px;
        height: 70px;
        max-height: 70px;

        // -----------------------------------------------------
        // 轨道
        // background: url('../../../../assets/img/general/Flow_Device_Static_Right.png') no-repeat 0px 0px;
        // 轨道+流动
        // background: url('../../../../assets/img/general/Flow_Device_Enter.gif') no-repeat 6px 7px,
        //     url('../../../../assets/img/general/Flow_Device_Static_Right.png') no-repeat 0px 0px;
        // 流动
        // background: url('../../../../assets/img/general/Flow_Device_Down.gif') no-repeat 6px 7px;
        // -----------------------------------------------------
        // 发电机能流方向值: 1发电 | 0无方向 | -1无向有线 | 2点亮无向
        &.electric {
          background: url("../../../../assets/img/general/Flow_Device_Up.gif") no-repeat 8px 0px,
            url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }

        // &.undirected {
        // }
        &.undirectedLine {
          // background: url('../../../../assets/img/general/Flow_Device_StaticIn_Vertical.png') no-repeat 12px 0px,
          //   url('../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png') no-repeat 0px 0px;
          // 改为空管道而非珠子在管道静止
          background: url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }

        &.undirectedLight {
          // background: url('../../../../assets/img/general/Flow_Device_StaticIn_Vertical.png') no-repeat 12px 0px,
          //   url('../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png') no-repeat 0px 0px;
          background: url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }

        // -----------------------------------------------------

        // 可封装
        .data {
          // transform: rotateX(180deg);
          height: 100%;
          line-height: 70px;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-end;
          padding: 0px;
          padding-left: 35px;
          font-size: 20px;
          color: #d7d7d7;

          position: absolute;
          left: 0px;
          top: 0px;
        }

        .label {
          background: transparent;
          padding: 0px 15px;
          font-size: 16px;
          color: #d7d7d7;
          position: absolute;
          right: 30px;
          top: 0px;
          height: 70px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .labelLine {
          border-right: 3px dashed red;
        }

        .labelNone {
          border-right: none;
        }

        // ..............
        // // top: 165px;
        // top: 205px;//228!
        // right: calc(~"50% + 60px");
        // bottom: calc(~"50% + 20px");
        // // left: 132px;
        // left: 50%;//107

        bottom: 128px;
        left: 49%;
        transform: translate(-50%, -57px);

        // border-bottom-left-radius: 10px;
        // padding: 0 0 5px 5px;
        padding: 0px;
        // .data {
        //   border-bottom-left-radius: 10px;
        // }
      }
    }
    .scene {
      flex: 1;
      // position: absolute;
      position: relative;

      // 原
      // min-height: 650px;
      // max-height: 650px;
      // min-width: 982px;
      // max-width: 982px;
      // 新
      // min-height: 616px;
      // max-height: 616px;
      // min-width: 1000px;
      // max-width: 1000px;
      width: 748px;
      height: 680px; //650?
      // background: #74818a;

      // 居中
      margin: auto;
      // top: 100px;//0!
      top: 0px; //0!
      left: 0;
      right: 0;
      bottom: 0;

      .container(@horizontal, @vertical) {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 2;
        .image {
          font-size: 0;
          transition: transform 0.2s linear;
          position: relative;
          &::before {
            transition: all 0.2s linear;
            content: "";
            opacity: 0;
            position: absolute;
            top: -10px;
            left: -10px;
            right: -10px;
            bottom: -10px;
            border-radius: 50%;
            z-index: -1;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
        // &:hover {
        //   .image {
        //     transform: translate(5px * @horizontal, 5px * @vertical);
        //     &::before {
        //       opacity: 1;
        //       box-shadow: -4px * @horizontal -4px * @vertical 6px 5px @borderColor;
        //     }
        //   }
        // }
        .name {
          line-height: 20px;
          .sc(16px, #ffffff);
          // margin-top: 10px;
          margin-top: -32px;
          // 处理PNG边距导致文字看似不居中
          margin-right: 12px;
        }
      }
      .generation-container {
        .container(-1, -1);
        top: 0px;
        // left: 50px;
        left: 0px;
        z-index: 2;
        .generationbox {
          // 212
          // W252px/H242px
          width: 195px;
          height: 212px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/general/flow_generation_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-position: center;
          background-position: center 0px; //-40px
          &:hover {
            background-image: url("../../../../assets/img/general/flow_generation_hover.png");
          }
        }
        // .name {
        //   margin-top: -70px;
        // }
      }

      .grid-container {
        .container(1, -1);
        top: 0px;
        // right: 50px;
        right: 0px;
        .gridbox {
          // 212
          // W252px/H242px
          width: 195px;
          height: 212px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/general/flow_grid_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-position: center;
          background-position: center 0px; //-40px
          &:hover {
            background-image: url("../../../../assets/img/general/flow_grid_hover.png");
          }
        }
        // .name {
        //   margin-top: -70px;
        // }
      }
      .inverter-container {
        .container(0, -1);
        top: 40%;
        left: 50%;
        transform: translate(-50%, -57px);
        .inverterbox {
          // 212
          // W252px/H242px
          width: 195px;
          height: 212px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/general/flow_inverter_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          &:hover {
            background-image: url("../../../../assets/img/general/flow_inverter_hover.png");
          }
        }
      }
      .battery-container {
        .container(-1, 1);
        // bottom: 15px;
        bottom: 50px; //0!
        // left: 50px;
        left: 0px;
        .image {
          // 212
          // W252px/H242px
          width: 195px;
          height: 212px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/general/flow_null_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          // padding-top: 60px;
          padding-top: 65px; //75!
          text-align: center;
          img {
            width: 77px;
            height: 69px;
            margin-right: 12px;
            // width: 5vw;
            // height: 4vw;
            // margin-right: 1vw;
          }
          &:hover {
            background-image: url("../../../../assets/img/general/flow_null_hover.png");
            img {
              margin-right: 5px;
            }
          }
        }
      }

      .consumption-container {
        .container(1, 1);
        // bottom: 15px;
        bottom: 50px; //0!
        // right: 38px;
        right: 0px;
        .consumptionbox {
          // 212
          // W252px/H242px
          width: 195px;
          height: 212px;
          // width: 15vw;
          // height: 15vw;
          background-image: url("../../../../assets/img/general/flow_consumption_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          &:hover {
            background-image: url("../../../../assets/img/general/flow_consumption_hover.png");
          }
        }
      }

      // 发电机alternator=============
      .alternator-container {
        .container(0, -1);
        bottom: -10px;
        left: 50%;
        margin-left: -4px;
        transform: translate(-50%, -57px);
        .alternatorbox {
          // 原207*146（0.85）=>176*124
          width: 176px;
          height: 124px;
          background-image: url("../../../../assets/img/general/flow_alternator_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          &:hover {
            background-image: url("../../../../assets/img/general/flow_alternator_hover.png");
          }
        }
        .label {
          margin-top: 5px;
          margin-left: -10px;
        }
      }
      // 发电机alternator=============

      // 继电器relay==================
      .relay-container {
        .container(0, -1);
        top: 108px;
        left: 50%;
        margin-left: -4px;
        transform: translate(-50%, -57px);
        .relaybox {
          // 原207*146（0.85）=>176*124
          width: 176px;
          height: 124px;
          background-image: url("../../../../assets/img/general/flow_relay_default.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          &:hover {
            background-image: url("../../../../assets/img/general/flow_relay_hover.png");
          }
        }
        .label {
          margin-top: 5px;
          margin-left: -4px;
        }
      }
      // 继电器relay==================

      // [原]
      // .value(@positive, @position) {
      //   position: absolute;
      //   &:not(.enable) {
      //     background: repeating-linear-gradient(
      //       45deg * @positive,
      //       #d7d7d7 0,
      //       #d7d7d7 30%,
      //       #eaf0f2 30%,
      //       #eaf0f2 50%
      //     );
      //     background-size: 30px 30px;
      //   }
      //   &.enable {
      //     background: repeating-linear-gradient(
      //       45deg * @positive,
      //       #1890ff 0,
      //       #1890ff 30%,
      //       #eaf0f2 30%,
      //       #eaf0f2 50%
      //     );
      //     background-size: 30px 30px;
      //     .data {
      //       color: #1890ff;
      //     }
      //   }
      //   &.positive {
      //     @keyframes positive {
      //       100% {
      //         background-position: -100%;
      //       }
      //     }
      //     animation: positive 18s linear infinite;
      //   }
      //   &.negative {
      //     @keyframes negative {
      //       100% {
      //         background-position: 100%;
      //       }
      //     }
      //     animation: negative 18s linear infinite;
      //   }
      //   .data {
      //     height: 100%;
      //     background: #202D35;
      //     display: grid;
      //     justify-content: center;
      //     justify-items: center;
      //     align-items: @position;
      //     padding: 10px;
      //     font-size: 20px;
      //     color: #d7d7d7;
      //   }
      // }
      // [新]
      // .value(-1, flex-end)
      .value(@positive, @position) {
        position: absolute;
        &:not(.enable) {
          background: repeating-linear-gradient(45deg * @positive, #d7d7d7 0, #d7d7d7 30%, #eaf0f2 30%, #eaf0f2 50%);
          background-size: 30px 30px;
        }
        &.enable {
          background: repeating-linear-gradient(45deg * @positive, #1890ff 0, #1890ff 30%, #eaf0f2 30%, #eaf0f2 50%);
          background-size: 30px 30px;
          .data {
            color: #1890ff;
          }
        }
        &.positive {
          @keyframes positive {
            100% {
              background-position: -100%;
            }
          }
          animation: positive 18s linear infinite;
        }
        &.negative {
          @keyframes negative {
            100% {
              background-position: 100%;
            }
          }
          animation: negative 18s linear infinite;
        }
        .data {
          height: 100%;
          background: #202d35;
          display: grid;
          justify-content: center;
          justify-items: center;
          align-items: @position;
          padding: 10px;
          font-size: 20px;
          color: #d7d7d7;
        }
      }
      // 光伏板(-1)
      .value-generation {
        // [原]
        // .value(-1, flex-end);
        // [新]..........
        position: absolute;
        // mw310/mh100
        min-height: 130px;
        max-height: 130px;
        min-width: 217px;
        max-width: 217px;
        &:not(.enable) {
          transform: rotateX(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
          // background-size: 100% 100%;
        }
        &.enable {
          background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
          // background-size: 100% 100%;
          .data {
            color: #1890ff;
            transform: rotateX(180deg);
          }
        }
        // [积极-出](-1)
        &.positive {
          transform: rotateX(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        }
        // [消极-进](-1)
        &.negative {
          transform: rotateX(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        }
        // 可封装
        .data {
          transform: rotateX(180deg);
          height: 100%;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-end;
          padding: 30px;
          font-size: 20px;
          color: #d7d7d7;
        }
        // ..............
        // top: 165px;
        top: 205px; //228!
        right: calc(~"50% + 60px");
        bottom: calc(~"50% + 20px");
        // left: 132px;
        left: 80px; //107
        border-bottom-left-radius: 10px;
        // padding: 0 0 5px 5px;
        padding: 0px;
        .data {
          border-bottom-left-radius: 10px;
        }
      }
      // 电网(1)
      .value-grid {
        // [原]
        // .value(1, flex-end);
        // [新]..........
        position: absolute;
        // mw310/mh100
        min-height: 130px;
        max-height: 130px;
        min-width: 217px;
        max-width: 217px;
        &:not(.enable) {
          transform: rotate(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
          // background-size: 100% 100%;
        }
        &.enable {
          background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
          // background-size: 100% 100%;
          .data {
            color: #1890ff;
            transform: rotate(180deg);
          }
        }
        // [积极-出](1)
        &.positive {
          transform: rotate(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        }
        // [消极-进](1)
        &.negative {
          transform: rotate(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        }
        // 可封装
        .data {
          transform: rotate(180deg);
          height: 100%;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-end;
          padding: 30px;
          font-size: 20px;
          color: #d7d7d7;
        }
        // ..............
        // top: 165px;
        top: 205px; //228!
        right: 132px;
        bottom: calc(~"50% + 20px");
        left: calc(~"50% + 70px");
        border-bottom-right-radius: 10px;
        padding: 0 5px 5px 0;
        .data {
          border-bottom-right-radius: 10px;
        }
      }
      // 电池(1)
      .value-battery {
        // [原]
        margin-top: 36px;
        // .value(1, flex-start);
        // [新]..........
        position: absolute;
        // mw310/mh100
        min-height: 130px;
        max-height: 130px;
        min-width: 217px;
        max-width: 217px;
        &:not(.enable) {
          // transform: rotateX(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
          // background-size: 100% 100%;
        }
        &.enable {
          background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
          // background-size: 100% 100%;
          .data {
            color: #1890ff;
            // transform: rotateX(180deg);
          }
        }
        // [积极-出](1)
        &.positive {
          // transform: rotateX(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        }
        // [消极-进](1)
        &.negative {
          // transform: rotateX(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        }
        // 可封装
        .data {
          // transform: rotateX(180deg);
          height: 100%;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-start;
          padding: 25px;
          font-size: 20px;
          color: #d7d7d7;
          .batterySetPrice{
            height: 150px;
          }
        }
        // ..............
        // top: calc(~"50% + 20px");
        top: calc(~"48% + 0px");
        right: calc(~"50% + 60px");
        bottom: 136px;
        // left: 132px;
        left: 80px; //107!
        border-top-left-radius: 10px;
        padding: 5px 0 0 5px;
        .data {
          border-top-left-radius: 10px;
        }
      }
      // 负载(-1)
      .value-consumption {
        // [原]
        margin-top: 36px;
        // .value(-1, flex-start);
        // [新]..........
        position: absolute;
        // mw310/mh100
        min-height: 130px;
        max-height: 130px;
        min-width: 217px;
        max-width: 217px;
        &:not(.enable) {
          transform: rotateY(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
          // background-size: 100% 100%;
        }
        &.enable {
          background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
          // background-size: 100% 100%;
          .data {
            color: #1890ff;
            transform: rotateY(180deg);
          }
        }
        // [积极-出](-1)
        &.positive {
          transform: rotateY(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Enter.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        }
        // [消极-进](-1)
        &.negative {
          transform: rotateY(180deg);
          background: url("../../../../assets/img/general/Flow_Device_Outer.gif") no-repeat 6px 7px,
            url("../../../../assets/img/general/Flow_Device_Static_Right.png") no-repeat 0px 0px;
        }
        // 可封装
        .data {
          transform: rotateY(180deg);
          height: 100%;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-start;
          padding: 25px;
          font-size: 20px;
          color: #d7d7d7;
        }
        // ..............
        // top: calc(~"50% + 20px");
        top: calc(~"48% + 0px");
        right: 132px;
        bottom: 136px;
        left: calc(~"50% + 70px");
        border-top-right-radius: 10px;
        padding: 5px 5px 0 0;
        .data {
          border-top-right-radius: 10px;
        }
      }

      // 继电器relay==========
      .value-relay {
        position: absolute;
        width: 30px;
        height: 70px;
        max-height: 70px;

        // -----------------------------------------------------
        // 轨道
        // background: url('../../../../assets/img/general/Flow_Device_Static_Right.png') no-repeat 0px 0px;
        // 轨道+流动
        // background: url('../../../../assets/img/general/Flow_Device_Enter.gif') no-repeat 6px 7px,
        //     url('../../../../assets/img/general/Flow_Device_Static_Right.png') no-repeat 0px 0px;
        // 流动
        // background: url('../../../../assets/img/general/Flow_Device_Up.gif') no-repeat 6px 7px;
        // -----------------------------------------------------
        // 微逆流向：1发电 | 0无方向 | -1暂未定义 | 2点亮无向
        &.electric {
          background: url("../../../../assets/img/general/Flow_Device_Down.gif") no-repeat 8px 0px,
            url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }
        &.undirected {
        }
        &.undeclared {
        }
        &.undirectedLight {
          // background: url('../../../../assets/img/general/Flow_Device_StaticIn_Vertical.png') no-repeat 12px 0px,
          //   url('../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png') no-repeat 0px 0px;
          background: url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }
        // -----------------------------------------------------

        // 可封装
        .data {
          // transform: rotateX(180deg);
          height: 100%;
          line-height: 70px;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-end;
          padding: 0px;
          padding-left: 35px;
          font-size: 20px;
          color: #d7d7d7;

          position: absolute;
          left: 0px;
          top: 0px;
        }
        // ..............
        // // top: 165px;
        // top: 205px;//228!
        // right: calc(~"50% + 60px");
        // bottom: calc(~"50% + 20px");
        // // left: 132px;
        // left: 50%;//107

        top: 264px;
        left: 49%;
        transform: translate(-50%, -57px);

        // border-bottom-left-radius: 10px;
        // padding: 0 0 5px 5px;
        padding: 0px;
        // .data {
        //   border-bottom-left-radius: 10px;
        // }
      }
      // 发电机alternator==========
      .value-alternator {
        position: absolute;
        width: 30px;
        height: 70px;
        max-height: 70px;
        // -----------------------------------------------------
        // 轨道
        // background: url('../../../../assets/img/general/Flow_Device_Static_Right.png') no-repeat 0px 0px;
        // 轨道+流动
        // background: url('../../../../assets/img/general/Flow_Device_Enter.gif') no-repeat 6px 7px,
        //     url('../../../../assets/img/general/Flow_Device_Static_Right.png') no-repeat 0px 0px;
        // 流动
        // background: url('../../../../assets/img/general/Flow_Device_Down.gif') no-repeat 6px 7px;
        // -----------------------------------------------------
        // 发电机能流方向值: 1发电 | 0无方向 | -1无向有线 | 2点亮无向
        &.electric {
          background: url("../../../../assets/img/general/Flow_Device_Up.gif") no-repeat 8px 0px,
            url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }
        &.undirected {
        }
        &.undirectedLine {
          // background: url('../../../../assets/img/general/Flow_Device_StaticIn_Vertical.png') no-repeat 12px 0px,
          //   url('../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png') no-repeat 0px 0px;
          // 改为空管道而非珠子在管道静止
          background: url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }
        &.undirectedLight {
          // background: url('../../../../assets/img/general/Flow_Device_StaticIn_Vertical.png') no-repeat 12px 0px,
          //   url('../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png') no-repeat 0px 0px;
          background: url("../../../../assets/img/general/Flow_Device_StaticOut_Vertical.png") no-repeat 0px 0px;
        }
        // -----------------------------------------------------

        // 可封装
        .data {
          // transform: rotateX(180deg);
          height: 100%;
          line-height: 70px;
          // background: #202D35;
          background: transparent;
          display: grid;
          justify-content: center;
          justify-items: center;
          // align-items: @position;
          align-items: flex-end;
          padding: 0px;
          padding-left: 35px;
          font-size: 20px;
          color: #d7d7d7;

          position: absolute;
          left: 0px;
          top: 0px;
        }
        .label {
          background: transparent;
          padding: 0px 15px;
          font-size: 16px;
          color: #d7d7d7;
          position: absolute;
          right: 30px;
          top: 0px;
          height: 70px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .labelLine {
          border-right: 3px dashed red;
        }
        .labelNone {
          border-right: none;
        }
        // ..............
        // // top: 165px;
        // top: 205px;//228!
        // right: calc(~"50% + 60px");
        // bottom: calc(~"50% + 20px");
        // // left: 132px;
        // left: 50%;//107

        bottom: 128px;
        left: 49%;
        transform: translate(-50%, -57px);

        // border-bottom-left-radius: 10px;
        // padding: 0 0 5px 5px;
        padding: 0px;
        // .data {
        //   border-bottom-left-radius: 10px;
        // }
      }
    }

    // 滚动条
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
  }
  .eceg-log{
    border: 1px solid rgba(198, 209, 221, 0.5);
    display: flex;
    padding: 50px 100px;
    flex-direction: column;
    justify-content: space-between;
    .top{
      width: 100%;
      flex: 1;
    }
    .center{
      width: 100%;
      flex: 1;
      position: static;
      top: auto;
      left: auto;
      transform: none;
       display: flex;
      //  align-items: center;
       justify-content: center;
       .data-value{
        color:#1890ff;
        font-size:20px;
       }
       .dev-flow{
          width: 225px;
          height: 160px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          position: relative;
          .dev-flow-box{
              width: 100%;
              height: 96%;
              background-image: url("../../../../assets/img/general/flow_inverter_default.png");
              background-repeat: no-repeat;
              background-size: 100% 140%;
              background-position: center;
              &:hover {
                 background-size: 110% 149%;
              }
          }

         .flow-effects{
          position: absolute;
          top: -134px;
          height: 150px;
          width: 600px;
          background-image: url("../../../../assets/img/devflow/top.png");
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100%;
          .grid-data{
            position: absolute;
            top: 30px;
            left: 116px;
          }
          .family-load-data{
            position: absolute;
            top: 30px;
            right: 116px;
          }
         .grid{
          position: absolute;
          left: -166px;
          top: -74px;
          width: 200px;
          height:180px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          position: relative;
           .grid-flow{
             width: 100%;
             height: 96%;
             background-image: url("../../../../assets/img/devflow/flow_grid.png");
             background-repeat: no-repeat;
             background-size: 100% 140%;
             background-position: center;
             &:hover {
                background-size: 110% 149%;
             }
           }
         }
         .family-loadsc{
          position: absolute;
          right: -577px;
          top: -275px;
          width: 193px;
          height: 172px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          position: relative;
          .family-flow{
            width: 100%;
            height: 96%;
            background-image: url("../../../../assets/img/devflow/flow_consumption.png");
            background-repeat: no-repeat;
            background-size: 100% 140%;
            background-position: center;
            &:hover {
               background-size: 110% 149%;
           }
         }
         }
          }
        //  .flow-effectsgif{
        //    background-image: url("../../../../assets/img/devflow/dev_fz_dw.gif");
        //  }
         .flow-effects-dw{
           background-image: url("../../../../assets/img/devflow/dev_dw.gif");
         }
         .flow-effects-dw-dev{
           background-image: url("../../../../assets/img/devflow/dw_dev.gif");
         }
         .flow-effects-fd{
           background-image: url("../../../../assets/img/devflow/dev_fz_dw.gif");
         }
         .flow-effects-dw-dev-jt{
           background-image: url("../../../../assets/img/devflow/dw_DEV_JT.gif");
         }
         .flow-effects-dw-dev-fz{
           background-image: url("../../../../assets/img/devflow/dw_dev_fz.gif");
         }
        .flowBottomleft{
          position: absolute;
          bottom: -195px;
          left: -194px;
          height: 188px;
          width: 287px;
          background-image: url("../../../../assets/img/devflow/botLeft.png");
          background-repeat: no-repeat;
          background-position: center;
           background-size: 100%;
           .dc-data{
            
            .dc-data-soc{
              position: absolute;
              top: 76px;
              left: -86px;
            }
            .dc-data-value{
              position: absolute;
              top: 135px;
              left: 113px;
            }
            
           }
          .dc-flow{
          position: absolute;
          left: -165px;
          top: 59px;
          width: 200px;
          height:180px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          position: relative;
          .battery-img{
            position: absolute;
            bottom: 69px;
            left: 55px;
          }
           .battow-flow{
             width: 100%;
             height: 96%;
             background-image: url("../../../../assets/img/general/flow_null_default.png");
             background-repeat: no-repeat;
             background-size: 100% 140%;
             background-position: center;
             
             &:hover {
                background-size: 110% 149%;
             }
           }
          }
         }
         .flowBottomleftdev{
           background-image: url("../../../../assets/img/devflow/dc_dev.gif");
         }
         .flowBottomleftDC{
          background-image: url("../../../../assets/img/devflow/dev_dc.gif");
         }
        .flowBottomright{
          position: absolute;
          bottom: -195px;
          right: -194px;
          height: 188px;
          width: 287px;
          background-image: url("../../../../assets/img/devflow/botRight.png");
          background-repeat: no-repeat;
          background-position: center;
           background-size: 100%;
           .fz-data{
            position: absolute;
            top: 135px;
            right: 113px;
           }
          .dc-flow{
          position: absolute;
          right: -265px;
          top: 84px;
          width: 177px;
          height: 154px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          position: relative;
           .battow-flow{
             width: 100%;
             height: 96%;
             background-image: url("../../../../assets/img/devflow/flow_loed.png");
             background-repeat: no-repeat;
             background-size: 100% 140%;
             background-position: center;
             &:hover {
                background-size: 110% 149%;
             }
           }
          }
         }
         .flowBottomrightgif{
           background-image: url("../../../../assets/img/devflow/dev_fz.gif");
         }
        .center-flow-pv{
           position: absolute;
           left: -186px;
           height: 188px;
           width: 208px;
           background-image: url("../../../../assets/img/devflow/centerPV.png");
          //  background-image: url("../../../../assets/img/devflow/pv_dev.gif");
           background-repeat: no-repeat;
           background-position: center;
           background-size: 100%;
           .pv-data{
            position: absolute;
            top: 135px;
            left: 106px;
           }
           .dc-flow{
            position: absolute;
            left: -171px;
            top: -14px;
            width: 200px;
            height:180px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
           .battow-flow{
             width: 100%;
             height: 96%;
             background-image: url("../../../../assets/img/devflow/flow_generation.png");
             background-repeat: no-repeat;
             background-size: 100% 140%;
             background-position: center;
             &:hover {
                background-size: 110% 149%;
             }
           }
          }
         }
         .center-flow-pv-dev{
             background-image: url("../../../../assets/img/devflow/pv_dev.gif");
         }
        .center-flow-generator{
           position: absolute;
           right: -186px;
           height: 188px;
           width: 208px;
           background-image: url("../../../../assets/img/devflow/centerPV.png");
           background-repeat: no-repeat;
           background-position: center;
          background-size: 100%;
          .generator-data{
            position: absolute;
            top: 135px;
            right: 106px;
          }
           .dc-flow{
            position: absolute;
            right: -161px;
            top: -11px;
            width: 182px;
            height: 162px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
           .battow-flow{
             width: 100%;
             height: 96%;
             background-image: url("../../../../assets/img/devflow/flow_gengel.png");
             background-repeat: no-repeat;
             background-size: 100% 140%;
             background-position: center;
             &:hover {
                background-size: 110% 149%;
             }
           }
          }
         }
         .center-flow-fdj-dev{
             background-image: url("../../../../assets/img/devflow/fdj_dev.gif");
         }
      }
    }
    .bottom{
      width: 100%;
       flex: 1;
    }
  }
}
.deviceStatisticAdaptNew {
  .AdaptBoxOut {
    width: 100%;

    .AdaptBoxIn {
      display: flex;
      flex-direction: row;
      height: 100%;
    }
  }
}

.dialogNew {
  .list {
    display: grid;
    grid-template-columns: auto auto auto auto;
    .sc(14px, rgba(255, 255, 255, 0.7));
    // border: 1px solid @borderColor;
    border: 1px solid rgba(198, 209, 221, 0.5);

    .item {
      line-height: 40px;
      padding: 0 30px;

      &:nth-child(8n + 5),
      &:nth-child(8n + 6),
      &:nth-child(8n + 7),
      &:nth-child(8n + 8) {
        background: #293942;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.dataBox {
  display: flex;
  flex-direction: column;

  .topLine {
    background: rgba(65, 80, 90, 1);
  }

  .dataContent {
    background: rgba(255, 255, 255, 0.01);
  }

  .topLine,
  .dataContent {
    display: grid;
    grid-template-columns: repeat(4, 185px);
  }

  .topName,
  .item {
    // height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #74818a;
    border-right: 1px solid #74818a;
    padding: 0px 16px !important;
    background: rgba(255, 255, 255, 0.01) !important;
  }

  .topName {
    border-bottom: none;
  }

  .topName:last-child {
    border-right: none;
  }

  .item:last-child {
    border-bottom: none;
  }

  .item:nth-last-child(2) {
    border-bottom: none;
  }

  .item:nth-child(4n + 4) {
    border-right: none;
  }
}

// 能流值的样式修改
.valUnitStyle {
  .valStyle {
    color: #33ffb6;
    font-size: 16px;
    font-weight: bold;
    margin-right: 4px;
  }

  .unitStyle {
    color: #ffffff;
    font-size: 12px;
  }
}

// 溢出滚动时右下角方块
// ::webkit-scrollbar-corner {
//   background-color: red!important;
// }
</style>